import React from "react";
import styles from "./suggestedorder.module.css";
import Head from "next/head";
import { useState } from "react";
import { Box, colors, Modal, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Image from "next/image";
import block1 from "../../public/image/suggester-order/suggested_order_blck1_img.webp";
import block2 from "../../public/image/suggester-order/suggested_order_blck2_img.webp";
import block4 from "../../public/image/suggester-order/suggested_order_blck4_img.webp";
import block5 from "../../public/image/suggester-order/suggested_order_blck5_img.webp";
import block6 from "../../public/image/suggester-order/suggested_order_blck6_img.webp";
import block7 from "../../public/image/suggester-order/suggested_order_blck7_img.webp";
import block8 from "../../public/image/suggester-order/suggested_order_blck8_img.webp";
import block9 from "../../public/image/suggester-order/suggested_order_blck9_img.webp";
import block10 from "../../public/image/suggester-order/suggested_order_blck10_img.webp";
import block11 from "../../public/image/suggester-order/suggested_order_blck11_img.webp";
import block12 from "../../public/image/suggester-order/suggested_order_blck12_img.webp";
import block13 from "../../public/image/suggester-order/suggested_order_blck13_img.webp";
import block14 from "../../public/image/suggester-order/suggested_order_blck14_img.webp";
import block15 from "../../public/image/suggester-order/suggested_order_blck15_img.webp";
import block16 from "../../public/image/suggester-order/suggested_order_blck16_img.webp";
import block17 from "../../public/image/suggester-order/suggested_order_blck17_img.webp";
import block18 from "../../public/image/suggester-order/suggested_order_blck18_img.webp";
import block19 from "../../public/image/suggester-order/suggested_order_blck19_img.webp";
import block20 from "../../public/image/suggester-order/suggested_order_blck20_img.webp";
import block21 from "../../public/image/suggester-order/suggested_order_blck21_img.webp";
import block22 from "../../public/image/suggester-order/suggested_order_blck22_img.webp";
import block23 from "../../public/image/suggester-order/suggested_order_blck23_img.webp";
import block24 from "../../public/image/suggester-order/suggested_order_blck24_img.webp";
import block25 from "../../public/image/suggester-order/suggested_order_blck25_img.webp";
import block26 from "../../public/image/suggester-order/suggested_order_blck26_img.webp";
import block27 from "../../public/image/suggester-order/suggested_order_blck27_img.webp";
import block28 from "../../public/image/suggester-order/suggested_order_blck28_img.webp";
import block29 from "../../public/image/suggester-order/suggested_order_blck29_img.webp";
import block30 from "../../public/image/suggester-order/suggested_order_blck30_img.webp";
import block31 from "../../public/image/suggester-order/suggested_order_blck31_img.webp";
import block32 from "../../public/image/suggester-order/suggested_order_blck32_img.webp";
import block33 from "../../public/image/suggester-order/suggested_order_blck33_img.webp";
import block34 from "../../public/image/suggester-order/suggested_order_blck34_img.webp";
import block35 from "../../public/image/suggester-order/suggested_order_blck35_img.webp";
import block37 from "../../public/image/suggester-order/suggested_order_blck37_img.webp";
import MysteryBannerNew from "../../components/MysteryBannerNew/MysteryBannerNew";

function Index() {
  const handleOpen = () => setOpen(true);
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Head>
        <title>
          Suggested Order of Practice | School of Our Divine Infinite Being
        </title>
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta
          name="keywords"
          content="Suggested Order of Practice, Ritual Praxis, Eddie Paredes, Theurgic Training, Initiatory Protocol, Greater Arcana Tarot, Planetary Invocation, Astrology, Raja Yoga, Kriya Kundalini Yoga, Theurgy, School of Our Divine Infinite Being"
        />
        <meta
          name="description"
          content="Explore the Suggested Order of Practice in the School of Our Divine Infinite Being. From natal astrology and Raja Yoga to planetary meditations and the Grand Theurgic Invocation, follow the structured path of the 15-month initiatory protocol."
        />
        <meta name="author" content="School of Our Divine Infinite Being" />
        <meta name="subject" content="Theurgic Education and Ritual Practice" />
        <meta name="language" content="English" />
        <meta name="geo.region" content="US" />

        <meta
          property="og:title"
          content="Suggested Order of Practice | School of Our Divine Infinite Being"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/suggested_order_practice_og_img.webp"
        />
        <meta
          property="og:image:alt"
          content="Sacred ritual progression steps in the School of Our Divine Infinite Being"
        />
        <meta
          property="og:description"
          content="Discover the structured sequence of spiritual training in the School of Our Divine Infinite Being. A time-tested initiatory path combining astrology, yoga, planetary invocation, and theurgy."
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="627" />
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/suggested-order"
        />

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          property="twitter:image"
          content="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/suggested_order_practice_og_img.webp"
        />
        <meta
          property="twitter:title"
          content="Suggested Order of Practice | School of Our Divine Infinite Being"
        />
        <meta
          property="twitter:url"
          content="https://www.divineinfinitebeing.com/suggested-order"
        />
        <meta
          property="twitter:description"
          content="Follow the suggested order of practice in the School of Our Divine Infinite Being: a 15-month path of ritual praxis, meditation, and theurgy."
        />

        <link
          rel="canonical"
          href="https://www.divineinfinitebeing.com/suggested-order"
        />
      </Head>


      <div className={styles.suggested_order_page_main}>
        {/* {/ <!------Main Banner section-------> /} */}
        <div className={styles.perennial_mandalism_blockone}>
          <div className={styles.perennial_mandalism_banner_main_wrpr}>
            <div className={styles.perennial_mandalism_banner_left}>
              <div className={styles.bannerLogo}>
                <span className={styles.logoviewlink} onClick={handleOpen}>
                  <img
                    src={`${process.env.cloud_url2}assets/images/viewicon.png`}
                  />
                </span>
                <img
                  src={`${process.env.cloud_url2}assets/images/logobanner.webp`}
                />
              </div>
              <h1 data-text="SCHOOL OF OUR DIVINE">SCHOOL OF OUR DIVINE </h1>
              <h1 data-text="infinite being">INFINITE BEING</h1>

              <h2>Polytheistic Monism - Divine Theurgy - Oracle to the Gods</h2>
              <div
                className={`${styles.perennial_mandalism_bottombannerbg} ${styles.bannerboxtxt}`}
              >
                <div className={styles.yellow_bar}></div>
              </div>
            </div>
          </div>
        </div>

        <MysteryBannerNew/>

        <div className={styles.suggested_order_page_blck_section_main}>
          <div className={styles.suggested_order_page_part1}>
            <div class={styles.common_width}>
              <div className={styles.orange_heading_section}>
                <div
                  className={`${styles.countDiv} ${styles.titleblock} ${styles.withsubtitle}`}
                >
                  <div className={styles.column}>
                    <div className={`${styles.col12} ${styles.bgifive}`}>
                      <h1>
                        Suggested Order of Practice in the School of Our Divine
                        Infinite Being
                      </h1>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.blck_sec_common_width}>
              <div className={styles.blck1_main}>
                <div className={styles.image_section}>
                  <Image src={block1} alt="Block-1 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <div className={styles.content_yellow_bar_section}></div>
                    <p>
                      Within the School of our Divine Infinite Being, there are
                      many gates through which one may pass, and many ways to
                      stand before the sacred. We welcome casual practitioners,
                      explorers, and independent seekers to draw from our
                      teachings, meditations, and ritual forms in the ways that
                      most naturally serve their own path. No coercion stands in
                      the way of truth — only the open hand, the clear
                      invitation, and the limitless field of possibility.
                    </p>

                    <p>
                      Yet for those who have{" "}
                      <span>pledged themselves to the Inner Mysteries</span>
                      —especially those entering the full{" "}
                      <span>Fifteen-Month Initiatory Protocol</span>—the road is
                      not left to chance. For them, we offer a deliberate and
                      time-tested progression: an ordered sequence of practice
                      in which each step rests firmly upon the one before it in
                      an accelerated introduction. Our practices are a living
                      current—interlocking, compounding, and deepening—moving
                      the aspirant from the stillness of pure awareness into the
                      embodied radiance of divine participation, and from the
                      narrow bounds of human limitation into the full scope of
                      cosmic agency.
                    </p>

                    <p>
                      The disciplines build like the stones of a temple, each
                      one supporting the next until the structure stands whole
                      and luminous. As such, if you have newly found your way to
                      our work, you may find that what follows offers more than
                      can be absorbed in a short span of time when outside the
                      required disciplines of our inner Mystery Tradition. In
                      the course of time true theurgy matures as a living
                      tree—its roots sinking deep into your daily discipline,
                      its branches reaching toward the Infinite. You are free to
                      adapt the sequence to your own schedule and depth of
                      study, allowing each phase to ripen in its season until
                      the full measure of the practice reveals itself in you.
                    </p>

                    <p>
                      With that stated, and given that this manual is intended
                      for our inner initiates, the material that follows is
                      presented in its accelerated format, with recommendations
                      and timing based on the full dedication required. In our
                      structured path,{" "}
                      <span>
                        the first eleven requirements are traversed within the
                        initial three months
                      </span>
                      , each week devoted to a single step of direct practice.{" "}
                    </p>
                  </div>
                </div>
              </div>

              <div
                className={`${styles.blck1_main} ${styles.blck2_main} ${styles.flex_direction_reverse}`}
              >
                <div className={styles.image_section}>
                  <Image src={block2} alt="Block-2 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>
                      Before our initiates formally embark on this journey—and
                      as a prerequisite that may be undertaken at any time
                      beforehand—they must complete our{" "}
                      <span>Greater Arcana Tarot Trump Training</span>. This
                      training is an essential preparation for the decan
                      invocations that form the heart of the twelve-month
                      program which follows the initial three months. By
                      completing it, you ensure that, by the time you enter the
                      planetary, zodiacal, and transit-based operations, you are
                      already grounded in a living, personal relationship within
                      the Tarot architecture of ROTA—a framework that profoundly
                      develops the symbolic structure of the divine
                      intelligences you will call—rather than experimenting
                      without orientation.
                    </p>

                    <p>
                      While this prerequisite is not strictly required for a
                      conceptual understanding of the material that follows, we
                      strongly recommend that those working through this on
                      their own complete it beforehand. Doing so allows the
                      practices to take root in both skill and spirit, greatly
                      enhancing the depth and potency of the work that lies
                      ahead. Further details on the Greater Arcana Tarot{" "}
                    </p>

                    <p>
                      <span>
                        <i>Trump Training —</i>
                      </span>{" "}
                      including instruction, symbolism, and integration into the
                      decan cycle — can be found through our website and YouTube
                      channel.
                    </p>
                  </div>
                </div>
              </div>

              <div className={`${styles.blck3_main} ${styles.content_box_bg}`}>
                <h2 className={styles.sky_heading}>
                  The order of practice are as follows:
                </h2>
                <div className={styles.blck3_wrpr}>
                  <div
                    className={`${styles.blt_nmbr_cont_box} ${styles.yellow_bg}`}
                  >
                    <h4
                      className={`${styles.number_cont} ${styles.left_number_cont}`}
                      style={{
                        color: "#022028",
                        textShadow: "1px 1px 5px #ffea4f",
                      }}
                    >
                      01
                    </h4>
                    <h4
                      className={styles.number_cont}
                      style={{
                        color: "#022028",
                        textShadow: "1px 1px 5px #ffea4f",
                      }}
                    >
                      Review your Natal Astrology and begin studying the
                      Theurgic Ritual of the Pentagram
                    </h4>
                  </div>
                  <div
                    className={`${styles.blt_nmbr_cont_box} ${styles.orange_bg}`}
                  >
                    <h4
                      className={`${styles.number_cont} ${styles.left_number_cont}`}
                    >
                      02
                    </h4>
                    <h4 className={styles.number_cont}>
                      Begin the practice of Raja Yoga
                    </h4>
                  </div>
                  <div
                    className={`${styles.blt_nmbr_cont_box} ${styles.purple_bg}`}
                  >
                    <h4
                      className={`${styles.number_cont} ${styles.left_number_cont}`}
                    >
                      03
                    </h4>
                    <h4 className={styles.number_cont}>
                      Begin the practice of Kriya Kundalini Yoga
                    </h4>
                  </div>
                  <div
                    className={`${styles.blt_nmbr_cont_box} ${styles.violet_bg}`}
                  >
                    <h4
                      className={`${styles.number_cont} ${styles.left_number_cont}`}
                    >
                      04
                    </h4>
                    <h4 className={styles.number_cont}>
                      Begin the practice of Tantric Kundalini Yoga (chakra
                      embodiment)
                    </h4>
                  </div>
                  <div
                    className={`${styles.blt_nmbr_cont_box} ${styles.sky_bg}`}
                  >
                    <h4
                      className={`${styles.number_cont} ${styles.left_number_cont}`}
                    >
                      05
                    </h4>
                    <h4 className={styles.number_cont}>
                      Begin the Planetary Meditations
                    </h4>
                  </div>
                  <div
                    className={`${styles.blt_nmbr_cont_box} ${styles.green_bg}`}
                  >
                    <h4
                      className={`${styles.number_cont} ${styles.left_number_cont}`}
                      style={{ color: "#022028" }}
                    >
                      06
                    </h4>
                    <h4
                      className={styles.number_cont}
                      style={{ color: "#022028" }}
                    >
                      Practice the Grand Theurgic Invocation
                    </h4>
                  </div>
                  <div
                    className={`${styles.blt_nmbr_cont_box} ${styles.orange_bg}`}
                  >
                    <h4
                      className={`${styles.number_cont} ${styles.left_number_cont}`}
                    >
                      07
                    </h4>
                    <h4 className={styles.number_cont}>
                      Practice the Banishing Ritual of the Pentagram
                    </h4>
                  </div>
                  <div
                    className={`${styles.blt_nmbr_cont_box} ${styles.yellow_bg}`}
                  >
                    <h4
                      className={`${styles.number_cont} ${styles.left_number_cont}`}
                      style={{
                        color: "#022028",
                        textShadow: "1px 1px 5px #ffea4f",
                      }}
                    >
                      08
                    </h4>
                    <h4
                      className={styles.number_cont}
                      style={{
                        color: "#022028",
                        textShadow: "1px 1px 5px #ffea4f",
                      }}
                    >
                      Practice the Invocation Ritual or the Pentagram
                    </h4>
                  </div>
                  <div
                    className={`${styles.blt_nmbr_cont_box} ${styles.violet_bg}`}
                  >
                    <h4
                      className={`${styles.number_cont} ${styles.left_number_cont}`}
                    >
                      09
                    </h4>
                    <h4 className={styles.number_cont}>
                      Practice the Invocation of our Divine Infinite Being
                    </h4>
                  </div>
                  <div
                    className={`${styles.blt_nmbr_cont_box} ${styles.purple_bg}`}
                  >
                    <h4
                      className={`${styles.number_cont} ${styles.left_number_cont}`}
                    >
                      10
                    </h4>
                    <h4 className={styles.number_cont}>
                      Practice the Opening of the Gates
                    </h4>
                  </div>
                  <div
                    className={`${styles.blt_nmbr_cont_box} ${styles.green_bg}`}
                  >
                    <h4
                      className={`${styles.number_cont} ${styles.left_number_cont}`}
                      style={{ color: "#022028" }}
                    >
                      11
                    </h4>
                    <h4
                      className={styles.number_cont}
                      style={{ color: "#022028" }}
                    >
                      Planetary Invocation Training – Without the Gates
                    </h4>
                  </div>
                  <div
                    className={`${styles.blt_nmbr_cont_box} ${styles.sky_bg}`}
                  >
                    <h4
                      className={`${styles.number_cont} ${styles.left_number_cont}`}
                    >
                      12
                    </h4>
                    <h4 className={styles.number_cont}>
                      Zodiacal Invocation Training – Without the Gates
                    </h4>
                  </div>
                  <div
                    className={`${styles.blt_nmbr_cont_box} ${styles.orange_bg}`}
                  >
                    <h4
                      className={`${styles.number_cont} ${styles.left_number_cont}`}
                    >
                      13
                    </h4>
                    <h4 className={styles.number_cont}>
                      Culmination of the Foundational Cycle – The Natal
                      Blueprint Invocation
                    </h4>
                  </div>
                  <div
                    className={`${styles.blt_nmbr_cont_box} ${styles.yellow_bg}`}
                  >
                    <h4
                      className={`${styles.number_cont} ${styles.left_number_cont}`}
                      style={{
                        color: "#022028",
                        textShadow: "1px 1px 5px #ffea4f",
                      }}
                    >
                      14
                    </h4>
                    <h4
                      className={styles.number_cont}
                      style={{
                        color: "#022028",
                        textShadow: "1px 1px 5px #ffea4f",
                      }}
                    >
                      Entering the Ongoing Rhythm of Theurgic Life
                    </h4>
                  </div>
                </div>
                <p className={styles.white_cont}>
                  Now let us briefly introduce each of the thirteen steps in
                  turn, with their deeper instruction and full development to be
                  found in the chapters that follow.
                </p>
              </div>

              <div className={styles.orange_bar}>
                <h2>
                  Step One (week 1) - The Sacred Blueprint — Initiating Your
                  Path Through Personal Astrology
                </h2>
              </div>

              <div className={`${styles.blck1_main} ${styles.blck4_main}`}>
                <div className={styles.image_section}>
                  <Image src={block4} alt="Block-4 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>
                      Before entering the stillness of the Observer or engaging
                      the body's energetic unfolding, the serious student of the
                      School of our Divine Infinite Being begins with a
                      foundational initiation: the study of their{" "}
                      <span>astrological birth chart</span> and the study of the{" "}
                      <span>Theurgic Ritual of the Pentagram.</span>
                    </p>

                    <p>
                      Your chart is not a mere diagram of personality traits or
                      predictive possibilities—it is the{" "}
                      <span>cosmic blueprint</span> of your incarnation. It is
                      the pattern you entered into this life bearing, the map of
                      your soul’s trajectory, and the language through which the
                      gods of the heavens speak directly to you.
                    </p>

                    <p>
                      Just as no two stars shine with the same light, no two
                      natal charts radiate the same pattern of divine intention.
                    </p>

                    <p>
                      This first phase of the Work invites you to become
                      familiar with the basic structure of your chart—your Sun,
                      Moon, Ascendant, planetary positions, houses, and major
                      aspects. We encourage the casual practitioner to explore
                      this as deeply or lightly as they feel called. But for the
                      serious aspirant entering our 15-month Inner Mystery
                      protocol, this is <span>an essential beginning.</span>
                    </p>

                    <p>
                      Not because astrology is required as dogma—but because{" "}
                      <span>your unique configuration of cosmic rhythm</span>{" "}
                      holds vital keys to the unfolding of every practice that
                      will follow.
                    </p>

                    <p>
                      This is not an academic exercise. You are not learning
                      "about" yourself; you are{" "}
                      <span>
                        learning to see your soul reflected in the sky.
                      </span>
                    </p>
                  </div>
                  <h4 className={styles.yelow_heading}>
                    We recommend the following steps to initiate your
                    astrological alignment:
                  </h4>

                  <div
                    className={`${styles.blt_nmbr_cont_box} ${styles.yellow_bg}`}
                  >
                    <h4
                      className={styles.number_cont}
                      style={{
                        color: "#022028",
                        textShadow: "1px 1px 5px #ffea4f",
                      }}
                    >
                      Generate a full natal chart from a reliable source.
                    </h4>
                  </div>
                  <div
                    className={`${styles.blt_nmbr_cont_box} ${styles.orange_bg}`}
                  >
                    <h4 className={styles.number_cont}>
                      Begin learning the meaning of your{" "}
                      <span>rising sign, Sun,</span> and <span>Moon</span> as a
                      basic triad of identity, soul, and embodiment.
                    </h4>
                  </div>
                  <div
                    className={`${styles.blt_nmbr_cont_box} ${styles.purple_bg}`}
                  >
                    <h4 className={styles.number_cont}>
                      Note the placement of your <span>chart ruler</span> (the
                      planet ruling your Ascendant), and begin observing its
                      influence.
                    </h4>
                  </div>
                  <div
                    className={`${styles.blt_nmbr_cont_box} ${styles.violet_bg}`}
                  >
                    <h4 className={styles.number_cont}>
                      Follow the <span>transiting Moon</span> through your
                      chart’s houses and observe changes in mood, awareness, and
                      energy.
                    </h4>
                  </div>
                  <div
                    className={`${styles.blt_nmbr_cont_box} ${styles.sky_bg}`}
                  >
                    <h4 className={styles.number_cont}>
                      Begin a simple <span>transit journal</span>: observe how
                      the movement of the planets aligns with external events
                      and inner states.
                    </h4>
                  </div>
                </div>
              </div>

              <div
                className={`${styles.blck1_main} ${styles.blck5_main} ${styles.flex_direction_reverse}`}
              >
                <div className={styles.image_section}>
                  <Image src={block5} alt="Block-5 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>
                      It is also highly recommended that you receive at least
                      one <span>professional reading</span> from a seasoned
                      astrologer—someone who can reflect back to you what you
                      may not yet be able to perceive clearly. Not to define
                      you, but to open your vision.
                    </p>

                    <p>
                      This early initiation prepares the soul to begin{" "}
                      <span>thinking cosmically</span>—to no longer view their
                      path through the lens of randomness or personal striving
                      alone. It trains the practitioner to <span>witness</span>{" "}
                      rather than control, and to{" "}
                      <span>interpret divine timing</span> rather than resist
                      it.
                    </p>

                    <p>
                      From this beginning, the student begins to shift: life is
                      no longer a series of unrelated events, but a divine
                      unfolding. A map. A story in which you are both
                      participant and co-creator.
                    </p>

                    <p>
                      With this orientation in place, the journey into Raja
                      Yoga—the art of pure awareness and the seat of the
                      Observer—can truly begin.
                    </p>
                  </div>

                  <h4 className={styles.yelow_heading}>
                    Begin the study of the Theurgic Ritual of the Pentagram
                  </h4>

                  <div className={styles.content_section}>
                    <p>
                      From the very first week of the program—and continuing
                      without interruption through each subsequent week of the
                      initial three-month sequence—you are to maintain a steady,
                      ongoing study of{" "}
                      <span>The Theurgic Ritual of the Pentagram.</span>
                    </p>

                    <p>
                      We instruct that you dedicate a minimum of{" "}
                      <span>20 minutes per day, five days a week,</span> to this
                      study and internalization, regardless of which of the
                      eleven steps you are focusing on in a given week. This
                      daily work should include reading the text of the ritual
                      aloud, progressing from descriptive understanding to
                      practical application, contemplating its structure and
                      sequence, familiarizing yourself with its visualizations
                      and invocations, and reflecting on its deeper symbolism.
                      By approaching it in this manner—layer by layer, week by
                      week—you will be preparing both mind and body for the
                      moment of full performance.
                    </p>

                    <p>
                      When the time comes to enact the rite, it will not be as a
                      set of instructions followed from memory, but as a
                      well-lived current that has taken root in your
                      consciousness. Through this disciplined, sustained
                      approach, the ritual will cease to be an external form and
                      instead become a natural extension of your own theurgic
                      being.
                    </p>
                  </div>
                </div>
              </div>

              <div className={styles.orange_bar}>
                <h2>Step 2 (week 2) – Begin the Practice of Raja Yoga</h2>
              </div>

              <div className={`${styles.blck1_main} ${styles.blck6_main}`}>
                <div className={styles.image_section}>
                  <Image src={block6} alt="Block-6 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>
                      This step requires 4 days of practice with an estimate of
                      an hour in study and 30 minutes in practice. amily, and
                      even many of the employees in my traditional business.
                    </p>

                    <p>
                      For the first two days, take the time to read through our
                      instructions several times and copy into your journal only
                      what is necessary for actual practice, including the
                      pronouncement in the final meditation provided. Select
                      from the postures offered the one in which you feel most
                      comfortable and stable. As you copy into your journal the
                      essential elements, visualize the concepts taking root in
                      the deepest part of your mind. Rāja—the “awareness of the
                      Observer”—will then enter into every activity, from
                      meditation to theurgy, throughout all the steps that
                      follow.
                    </p>

                    <p>
                      Then, dedicate at least{" "}
                      <span>two to three consecutive days</span> to direct
                      practice of the final meditation as we have listed. Raja
                      Yoga is the discipline of <span>sovereign stillness</span>{" "}
                      — the enthronement of pure awareness beyond all mental
                      fluctuations. It is the training of the inner witness, the
                      silent ruler at the center of being, from which all ritual
                      action gains clarity and power.
                    </p>

                    <p>
                      Begin in a quiet space, free from interruption. Assume
                      your chosen meditation seat with dignity — as though you
                      were taking the throne of your own inner kingdom. Let the
                      breath settle into an even rhythm. Withdraw your attention
                      from outer distractions and allow the mind to rest in its
                      natural state, unclouded and awake.
                    </p>

                    <p>
                      The additional context we offer in Rāja Yoga is intended
                      to help orient the theurgist in the foundation of virtue
                      in the practice, and should be revisited and integrated
                      over time.
                    </p>

                    <p>
                      Once you have moved beyond this week, we strongly
                      recommend continuing the final meditation once or twice a
                      week to maintain your orientation in awareness—
                      <span>rooted in centrality and the witness state</span>—so
                      that it continues to support and deepen all practices that
                      follow. This is not a preliminary exercise to be
                      discarded, but an enduring discipline. Each session
                      reinforces the axis of stillness within you, establishing
                      the immovable center from which all your theurgical
                      operations will be conducted.
                    </p>

                    <p>
                      As you persist in this work week after week, the still
                      point within becomes unshakable—an inner throne from which
                      the mind surveys all without being swept away. Over time,
                      this cultivated stability grants you the ability to hold
                      unwavering focus in the midst of any rite, ensuring that
                      your invocations and divine appeals arise from a
                      consciousness that is perfectly balanced, lucid, and
                      sovereign.{" "}
                    </p>
                  </div>
                </div>
              </div>

              <div className={styles.orange_bar}>
                <h2>
                  Step 3 (week 3) – Begin the Practice of Kriya Kundalini Yoga
                </h2>
              </div>

              <div
                className={`${styles.blck1_main} ${styles.blck7_main} ${styles.flex_direction_reverse}`}
              >
                <div className={styles.image_section}>
                  <Image src={block7} alt="Block-7 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>
                      This step requires 4 days of practice with an estimate of
                      30 minutes each days.
                    </p>

                    <p>
                      For the first two days,{" "}
                      <span>copy the full kriya sequence</span> for Kundalini
                      Yoga into your journal exactly as given in your training
                      across the 7 postures. Even if it is stick figures draw
                      the postures in your journal with their name so you have a
                      visible reference during performance. Add in a brief
                      reminder of how to perform the breath of fire, as it is
                      used for all except the last posture.
                    </p>

                    <p>
                      Next,{" "}
                      <span>
                        study what you have written and picture each posture in
                        your mind’s eye,
                      </span>{" "}
                      seeing yourself perform them with precision. Notice where
                      the breath is meant to deepen, where the muscles engage,
                      and where the spine opens. This mental rehearsal ensures
                      that, when you enter physical practice, your body already
                      “knows” the sequence. Then, practice the postures without
                      full performance, allowing your body to naturally respond
                      to their positions. Hold each one for a minute or more,
                      taking deep, steady breaths.
                    </p>

                    <p>
                      Across two to three days, begin each session with 5 to 10
                      minutes of Rāja-style concentrated meditation, and then
                      proceed to practice <span>Kriya Kundalini Yoga</span>.
                      Perform all seven postures in succession, holding each
                      form for as long as is comfortable before moving to the
                      next. Maintain good vertical alignment of the spine, and
                      embody each posture as a living art of breath, movement,
                      and awareness—an energetic discipline designed to awaken
                      and release the currents along your spine.
                    </p>

                    <p>
                      As you work through the sequence, notice how each posture
                      opens specific segments of the spinal column, dissolves
                      energetic knots, and allows subtle waves of vitality to
                      circulate. Feel the spine becoming more alive and fluid
                      with every breath, as though each vertebra is drawing in
                      light. The rhythm of posture and breath together clears
                      pathways, stimulates the nervous system, and prepares your
                      body as the vessel for deeper states of theurgic union.
                    </p>

                    <p>
                      Once this week’s training is complete,{" "}
                      <span>
                        we recommend integrating Kriya into your ongoing
                        discipline
                      </span>
                      —practicing at least two to three times per week, and
                      daily if possible—incorporating Rāja meditation as an
                      opener whenever time permits. Over time, this sustained
                      work will keep the body supple, charged, and highly
                      receptive, ensuring that when theurgical rites are
                      performed, the temple of the body stands fully prepared
                      for the descent of the divine.
                    </p>
                  </div>
                </div>
              </div>

              <div className={styles.orange_bar}>
                <h2>
                  Step 4 (week 4) – Begin the Practice of Tantric Kundalini Yoga
                  (Chakra Embodiment)
                </h2>
              </div>

              <div className={`${styles.blck1_main} ${styles.blck8_main}`}>
                <div className={styles.image_section}>
                  <Image src={block8} alt="Block-8 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>
                      This step requires 4 days of practice with an estimate of
                      1 hour each day.
                    </p>

                    <p>
                      For the next two days, carefully copy the full sequence of
                      the Chakra Embodiment Practice onto a single page in your
                      journal, listing all seven chakras along with their
                      corresponding mantras and the keywords you personally
                      associate with each. This single-page reference will serve
                      as your quick, integrated overview of the whole system.
                    </p>

                    <p>
                      Then, dedicate one full page of your journal to each
                      chakra individually. On these pages, copy from our
                      material any passages, descriptions, or insights that
                      resonate most strongly with you. Beneath these, add your
                      own language, impressions, and reflections—describing how
                      you perceive each chakra in its vibrational form. Consider
                      noting colors, sensations, archetypal qualities, symbolic
                      images, and the specific way each center expresses itself
                      in your awareness.
                    </p>

                    <p>
                      As you transcribe, linger with each chakra, allowing its
                      qualities and symbols to become vivid in your mind. Note
                      its location, elemental correspondence, color, sound, and
                      the divine intelligence that dwells there. In the tantric
                      tradition, the chakras are living seats of power
                      (pīṭhas)—each an abode of a specific vibration of Shakti,
                      the creative force. In this way, your work becomes a
                      personal map of energetic experience and a testament to
                      your growing relationship with the subtle body.
                    </p>

                    <p>
                      Once the sequence is inscribed, dedicate two to three days
                      this week to the direct practice of embodying and
                      meditating on the chakra centers. Begin each session with
                      a 10-minute Rāja meditation, entering the stillness of the
                      witness state so that the mind is clear, centered, and
                      sovereign. From this foundation of pure awareness,
                      transition into a full Kriya Kundalini Yoga session,
                      moving through all seven postures in succession. This
                      union of deep mental stillness and dynamic spinal
                      activation prepares both the subtle and physical body for
                      Tantric Kundalini practice and the rising of Śakti through
                      the chakra meditation.
                    </p>
                  </div>
                </div>
              </div>

              <div
                className={`${styles.blck1_main} ${styles.blck9_main} ${styles.flex_direction_reverse}`}
              >
                <div className={styles.image_section}>
                  <Image src={block9} alt="Block-9 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>
                      Once the body and mind are prepared, turn to the chakra
                      work itself. Starting at the root, breathe life into each
                      center, feeling it awaken as a pulsing, radiant sphere of
                      awareness within you. As you ascend from chakra to chakra,
                      you climb a living ladder of consciousness—each rung
                      opening a gateway between the earth below and the heavens
                      above, joined through the luminous axis of your own spine.
                      The synergy of Rāja meditation, Kriya practice, and chakra
                      embodiment creates a unified current that allows Śakti to
                      rise unobstructed, energizing each center in turn until
                      the crown blossoms in full illumination.
                    </p>

                    <p>
                      In our more extensive curriculum, we recommend devoting a
                      full week to each chakra—journaling, meditating, and
                      deepening your relationship with its unique qualities.
                      This is still something we strongly encourage you to
                      explore in your ongoing work. However, the accelerated
                      nature of the twelve-week foundational program for the
                      Inner Mystery School calls for a condensed approach. For
                      this week, during all your practice days, you will move
                      through all seven chakras in a single, fully dedicated
                      30-minute meditation, from base to crown. Spend at least
                      four minutes with each center, resonating its mantra
                      several times with a few seconds of silence between each
                      repetition. As you work upward, focus on each mantra and
                      center with complete presence, allowing the entire
                      sequence to flow as an unbroken current of awakening. This
                      concentrated practice will give you a full-body, living
                      experience of the chakra system, which can then be
                      expanded into deeper, more focused work in the months and
                      years ahead.
                    </p>

                    <p>
                      After this week, we recommend moving through the full
                      ascent at least once each week, always in combination with
                      Rāja meditation and Kriya during your training period.
                      More frequent practice will only deepen embodiment. Over
                      time, this work imprints the chakras as fully inhabited
                      sanctums within your subtle body. They cease to be
                      abstract concepts and instead become tangible, accessible
                      realms—inner thrones from which the divine may speak and
                      act through you.
                    </p>

                    <p>
                      When united with the foundational stillness of Rāja Yoga
                      and the spinal vitality of Kriya Kundalini, Tantric Chakra
                      Embodiment completes the vertical channel, preparing you
                      to receive and direct the full force of planetary
                      invocation in theurgy.
                    </p>
                  </div>
                </div>
              </div>

              <div className={styles.orange_bar}>
                <h2>
                  Step 5 (week 5) – Begin the Practice of Planetary Meditations
                </h2>
              </div>

              <div className={`${styles.blck1_main} ${styles.blck10_main}`}>
                <div className={styles.image_section}>
                  <Image src={block10} alt="Block-10 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>
                      This step requires four days with anywhere between one to
                      two hours each
                    </p>

                    <p>
                      Once the vertical channel of the chakras is alive and
                      responsive, it is time to extend awareness beyond the body
                      and into the vast temple of the heavens. The Planetary
                      Meditations form the bridge between your personal
                      energetic system and the immense presences of the
                      planetary gods themselves.
                    </p>

                    <p>
                      This work unfolds over <span>four days</span>. The first
                      two are devoted to study and preparation. As you read
                      through the planetary meditations, copy into your journal
                      only what is necessary for you to visualize each planet
                      directly from your notes—focusing on essential details of
                      size, velocity, and <span>transconscious nature</span>.
                      For each planet, record at least four to five key points
                      in your own words. These notes should be clear and vivid
                      enough that, when you meditate, you can call each planet
                      to mind without referring back to the original text.{" "}
                    </p>

                    <p>
                      The final two days are dedicated to{" "}
                      <span>direct meditative practice</span>. On the first day,
                      meditate on the{" "}
                      <span>Earth, Moon, Sun, and inner planets</span>—Mercury,
                      Venus, and Mars—beginning in a place where you can see the
                      curve of the sky in all directions. Draw your awareness
                      into the vast body of the Earth beneath you, then bring
                      the Moon into view as a reflective mirror. One by one,
                      replace it with each planet, visualizing it at the Moon’s
                      distance, filling your awareness with its vast form, its
                      motion, and the quality of its presence.
                    </p>

                    <p>
                      On the second day, turn to the <span>outer planets</span>
                      —Jupiter, Saturn, Uranus, Neptune, and Pluto—using the
                      same sequence and method. In each vision, you are not
                      merely observing a celestial object; you are standing in
                      the presence of a god, feeling the weight of their
                      influence and the unique nature of their intelligence.
                    </p>

                    <p>
                      These meditations attune you to the harmonics of each
                      planetary being so that, when invoked in ritual, the
                      connection is immediate and visceral.{" "}
                      <span>
                        Revisit this meditation practice several times a year to
                        refresh and deepen your contact.
                      </span>{" "}
                      They are also an excellent introductory practice to share
                      with others—even those outside the Mystery School—as they
                      provide a direct and universal way to experience the
                      living intelligences of the heavens without requiring
                      prior initiation.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.suggested_order_page_part2}>
            <div className={styles.blck_sec_common_width}>
              <div className={styles.orange_bar}>
                <h2>Step 6 (week 6) – Practice the Grand Invocation</h2>
              </div>

              <div
                className={`${styles.blck1_main} ${styles.blck11_main} ${styles.flex_direction_reverse}`}
              >
                <div className={styles.image_section}>
                  <Image src={block11} alt="Block-11 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>
                      This step requires four days with anywhere between one to
                      two hours each
                    </p>

                    <p>
                      By this point, as directed in Week One, you will have been
                      studying <span>The Theurgic Ritual of the Pentagram</span>{" "}
                      daily for the past five weeks. In Week Six, we now begin
                      engaging the ritual in direct practice. If, at this stage,
                      you are not yet able to easily recall all the forms
                      invoked—naming them without looking at your materials—then
                      add four to five additional study sessions this week to
                      bring yourself fully up to speed. I will offer this
                      guidance here once, yet it applies equally to every
                      section that follows involving{" "}
                      <span>The Theurgic Ritual of the Pentagram</span>. While
                      you will still inscribe the ritual in your journal and
                      keep it on your altar for reference, your goal is to
                      commit the sequence to memory so the work flows without
                      interruption
                    </p>

                    <p>
                      For the first two days of this week, focus on the{" "}
                      <span>divine names</span> you will need to perform. Copy
                      them in their proper sequence into your journal, and for
                      each name, write two to three quick reference points that
                      will help you immediately orient yourself in the imaginal
                      body to its invocation and purpose.
                    </p>

                    <p>
                      Begin this work in a section of your journal where you
                      have set aside <span>20–30 blank pages</span>. This will
                      serve as the space in which you build out the complete
                      ritual set over the coming weeks. Into these pages,
                      inscribe the <span>Grand Invocation</span> with precision
                      and care, ensuring every divine name, sequence, and
                      visualization is recorded exactly. As you write, speak
                      each name aloud with its correct pronunciation, letting
                      the sound vibrate through you and take root in your
                      memory.
                    </p>

                    <p>
                      The Grand Invocation is far more than a verbal
                      recitation—it is a full rite in itself, a deliberate
                      passage from the finite self into conscious alignment with
                      the Infinite. With repeated practice, it becomes a living
                      threshold, the gateway through which all theurgical work
                      must pass and take its first breath.
                    </p>
                  </div>
                </div>
              </div>

              <div className={`${styles.blck1_main} ${styles.blck12_main}`}>
                <div className={styles.image_section}>
                  <Image src={block12} alt="Block-12 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>
                      Once the Grand Invocation has been committed to your
                      journal, devote the next two to three days to focused
                      rehearsal. Enter your chosen ritual space with full
                      attention, wearing your robe if you have one, and assume
                      an erect, steady posture. As you resonate with each divine
                      name,{" "}
                      <span>
                        visualize your imaginal body expanding beyond the
                        confines of individuality,
                      </span>{" "}
                      unfolding until it mirrors the full cosmic sphere.
                    </p>

                    <p>
                      See yourself as the ōchema—the subtle, luminous vehicle of
                      the soul—shaped as the microcosmic egg, suspended within
                      and perfectly aligned to the boundless Macrocosm. Feel the
                      radiance of your being extending to every point of the
                      horizon, the inner sun at your core answering to the great
                      vault of stars above. Hold this awareness as the
                      foundational state from which the ritual will be
                      performed,{" "}
                      <span>
                        for in this expansion you are no longer merely a
                        practitioner
                      </span>
                      ; you are the living axis{" "}
                      <span>where heaven and earth meet.</span>
                    </p>

                    <p>
                      This Invocation is the{" "}
                      <span>opening key of the Mystery School</span>, the act by
                      which the Microcosm is consciously brought into harmony
                      with the Macrocosm. Each divine name is a rung in an
                      ascent, yet also a deepening descent into the core of
                      divine being, from which all subsequent work takes its
                      power.
                    </p>

                    <p>
                      From this point forward,{" "}
                      <span>
                        integrate the Grand Invocation into every ritual
                      </span>
                      . It is the threshold of thresholds, the clearing of the
                      inner temple and the attunement to the divine continuum in
                      which all theurgical work unfolds. As your familiarity
                      grows, allow the words to move beyond memorization into
                      embodiment, so that each time it is performed, it becomes
                      an act of living presence rather than mere repetition.
                    </p>
                  </div>
                </div>
              </div>

              <div className={styles.orange_bar}>
                <h2>
                  Step 7 (week 7) – Practice the Banishing Ritual of the
                  Pentagram
                </h2>
              </div>

              <div
                className={`${styles.blck1_main} ${styles.blck13_main} ${styles.flex_direction_reverse}`}
              >
                <div className={styles.image_section}>
                  <Image src={block13} alt="Block-13 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>
                      This step requires four days with anywhere between two to
                      three hours each
                    </p>

                    <p>
                      This week, you will be performing the full{" "}
                      <span>Banishing Pentagram Ritual</span>, complete with the
                      calling of the guardians and the final pronouncement, all
                      following directly after the{" "}
                      <span>Grand Invocation.</span>
                    </p>

                    <p>
                      For the first two days, your task is to fully commit the
                      complete banishing sequence to memory. This includes not
                      only the words and divine names of the Demiurgos and the
                      daemons, but also the precise gestures, directional
                      movements, and visualizations that together form the full
                      structure of the rite.
                    </p>

                    <p>
                      Begin by carefully copying each pentagram into your
                      journal exactly as given, marking the arrows that indicate
                      both the banishing and invoking directions. Alongside each
                      pentagram, note its elemental correspondence—fire, water,
                      air, or earth—and record the name of the elemental daemon
                      associated with that quarter (Kratos, Eros, Erine, Janus).
                      Also list all four of the corresponding Minor Arcana card
                      names—<span>Dominion, Love, Peace, and Change</span>—along
                      with the planetary and zodiacal references for their
                      energies, and their tarot meanings.
                    </p>
                  </div>
                  <h4 className={styles.yelow_heading}>
                    Next, begin your physical rehearsal:
                  </h4>
                  <div
                    className={`${styles.blt_nmbr_cont_box} ${styles.yellow_bg}`}
                  >
                    <h4
                      className={styles.number_cont}
                      style={{
                        color: "#022028",
                        textShadow: "1px 1px 5px #ffea4f",
                      }}
                    >
                      Practice tracing the pentagrams in the air with accuracy
                      and deliberation.
                    </h4>
                  </div>
                  <div
                    className={`${styles.blt_nmbr_cont_box} ${styles.orange_bg}`}
                  >
                    <h4 className={styles.number_cont}>
                      Intone the divine names with proper pronunciation and
                      resonance.
                    </h4>
                  </div>
                  <div
                    className={`${styles.blt_nmbr_cont_box} ${styles.purple_bg}`}
                  >
                    <h4 className={styles.number_cont}>
                      Intone the divine names with proper pronunciation and
                      resonance.
                    </h4>
                  </div>
                </div>
              </div>

              <div className={`${styles.blck1_main} ${styles.blck14_main}`}>
                <div className={styles.image_section}>
                  <Image src={block14} alt="Block-14 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>
                      Once you have inscribed the sequence, perform the ritual
                      for at least two to three consecutive days, taking your
                      time to fully visualize each stage. A standard banishing
                      ritual may take around twenty minutes; here, however, you
                      should extend the work, moving slowly and deliberately,
                      allowing it to fill a full hour. Stand with the full
                      awareness that your body is a bridge between heaven and
                      earth. Trace each pentagram as though carving it into the
                      very fabric of space, watching the lines ignite with
                      luminous force. Speak each divine name so that it
                      resonates beyond the walls of your space, carrying into
                      the infinite order of the cosmos.
                    </p>

                    <p>
                      From this point forward, the Banishing Ritual of the
                      Pentagram becomes your <span>primary daily</span> anchor
                      when no other ritual is performed. We suggest practicing
                      it every day, though at the very least a couple of times
                      per week. This is the rite you will perform more often
                      than any other, and it stands on its own as a complete and
                      powerful operation.
                    </p>

                    <p>
                      It is the first act upon entering the sacred space,
                      ensuring that your work begins in clarity, balance, and
                      full attunement to the divine architectures.{" "}
                      <span>
                        Performed with consistency, it not only clears the outer
                        field, but also purifies the inner temple
                      </span>
                      —the mind, the heart, and the will—so that every
                      subsequent operation unfolds within a sanctified sphere.
                      Over time, this ritual becomes second nature, a seamless
                      gateway into the sacred current, and the foundation upon
                      which all other theurgical work rests.
                    </p>
                  </div>
                </div>
              </div>

              <div className={styles.orange_bar}>
                <h2>
                  Step 8 (week 8) – Practice the Invocation Ritual of the
                  Pentagram
                </h2>
              </div>

              <div
                className={`${styles.blck1_main} ${styles.blck15_main} ${styles.flex_direction_reverse}`}
              >
                <div className={styles.image_section}>
                  <Image src={block15} alt="Block-15 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>
                      This step requires four days with a deliberate hour each
                      day
                    </p>

                    <p>
                      By this stage, you have already studied the elements in
                      depth, inscribed the directional arrows for both banishing
                      and invoking forms, and committed the elemental
                      correspondences to memory. Your journal now contains all
                      the necessary visual keys for the work ahead. This week,
                      we turn to the{" "}
                      <span>Invoking Ritual of the Pentagram</span>—the mirror
                      operation to the banishing rite.
                    </p>

                    <p>
                      Here, the structure remains nearly identical to what you
                      have already performed. You begin with the{" "}
                      <span>Grand Invocation</span> to align yourself with the
                      Infinite and establish the vertical axis of your theurgic
                      presence. You then move through the elemental quarters in
                      the same order as before. The difference lies in the
                      moment after the banishing sequence: instead of closing
                      the ritual you move to directly invoke the banished
                      energies and fully embody the elemental forces of the
                      Demiurgos.
                    </p>

                    <p>
                      Using the exact same language as in the banishing rite,
                      you will trace the <span>invoking pentagram</span> for the
                      element in that quarter—just as precisely as you traced
                      the banishing form, but now in the invoking direction. As
                      you do so, visualize the elemental power streaming in
                      through the pentagram’s lines, flooding the ritual space
                      with its living force. Where the banishing sequence clears
                      and sanctifies, the invoking sequence summons and fills.
                    </p>

                    <p>
                      When calling upon each element, let the visualization
                      shift from dispersing and dissolving to{" "}
                      <span>embodying and inhabiting</span>. See the presence of
                      that element—fire, water, air, or earth—manifest vividly
                      before you and then take up residence within your imaginal
                      body. Feel its currents moving through you:
                    </p>
                  </div>
                </div>
              </div>

              <div className={`${styles.blck1_main} ${styles.blck16_main}`}>
                <div className={styles.image_section}>
                  <Image src={block16} alt="Block-16 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div
                    className={`${styles.blt_nmbr_cont_box} ${styles.red_bg}`}
                  >
                    <h4 className={styles.number_cont}>
                      Fire igniting will and courage.
                    </h4>
                  </div>
                  <div
                    className={`${styles.blt_nmbr_cont_box} ${styles.sky_bg}`}
                  >
                    <h4 className={styles.number_cont}>
                      Water awakening empathy and intuition.
                    </h4>
                  </div>
                  <div
                    className={`${styles.blt_nmbr_cont_box} ${styles.yellow_bg}`}
                  >
                    <h4
                      className={styles.number_cont}
                      style={{
                        color: "#022028",
                        textShadow: "1px 1px 5px #ffea4f",
                      }}
                    >
                      Air sharpening clarity and thought.
                    </h4>
                  </div>
                  <div
                    className={`${styles.blt_nmbr_cont_box} ${styles.dark_green_bg}`}
                  >
                    <h4 className={styles.number_cont}>
                      Earth grounding stability and form.
                    </h4>
                  </div>
                  <div className={styles.content_section}>
                    <p>
                      For this week, you will perform the full{" "}
                      <span>banishing followed immediately by invoking</span> in
                      a single session, every day for four days in succession.
                      Each session should be unhurried—at least an hour—so you
                      have time to inhabit each quarter, feel the elemental
                      shift from banishing to invoking, and integrate the
                      presence before moving on.
                    </p>

                    <p>
                      Throughout these days, pay close attention to how the
                      elemental forces respond. You may notice that after
                      invoking, the space feels fuller, warmer, more vibrant.
                      The air may seem charged, the silence more alive. This is
                      the sign that the elemental currents have been not only
                      called but anchored in your ritual field.
                    </p>

                    <p>
                      As with the banishing rite, stand with the full awareness
                      that you are the bridge between heaven and earth—the
                      microcosm drawing the macrocosm into form. The pentagrams
                      are your keys; the divine names, your calls; and your
                      body, the temple in which these forces dwell. By the end
                      of this week, you should be able to perform both banishing
                      and invoking sequences fluently, understanding them not as
                      two separate rituals but as two halves of a single
                      movement: the breathing out and the breathing in of the
                      elemental powers in divine order.
                    </p>

                    <p>
                      The invoking pentagrams may be performed at any time in
                      harmony with the banishing pentagrams, but they take on
                      their highest purpose when performed in{" "}
                      <span>
                        preparation for the invocation of Our Divine Infinite
                        Being
                      </span>
                      . In the ideal rhythm of the work, the banishing first
                      clears and aligns the elemental pentagrams, and the
                      invoking fully embodies their energies, calling the powers
                      to their stations within the circle.
                    </p>

                    <p>
                      Think of this as <span>setting the throne</span>: the
                      temple space becomes ordered, the elemental guardians take
                      their places, and the currents of fire, water, air, and
                      earth stand in perfect readiness. Only then is the way
                      fully prepared for the descent of{" "}
                      <span>our Divine Infinite Being</span>, who enters not
                      into a void, but into a radiant, living order that
                      reflects the harmony of the cosmos itself.
                    </p>
                  </div>
                </div>
              </div>

              <div className={styles.orange_bar}>
                <h2>
                  Step 9 (week 9) – Practice the Invocation of Our Divine
                  Infinite Being
                </h2>
              </div>

              <div
                className={`${styles.blck1_main} ${styles.blck17_main} ${styles.flex_direction_reverse}`}
              >
                <div className={styles.image_section}>
                  <Image src={block17} alt="Block-17 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>
                      This step requires four days with an expected 30 minutes
                      each day
                    </p>

                    <p>
                      On <span>Day One</span>, you will write the full
                      Invocation of Our Divine Infinite Being into your journal
                      with utmost care, ensuring each word is inscribed clearly
                      and correctly. Once written, recite the invocation aloud
                      at least five to six times, focusing on precision of
                      pronunciation, clarity of tone, and the full presence of
                      your heart in each word. Let the sound fill the space and
                      resonate in your body, so the language begins to inhabit
                      you as much as you inhabit it.
                    </p>
                  </div>

                  <h3 className={styles.sky_heading_35}>
                    On Days Two through Four, you will perform the full ritual
                    sequence, but now following as natural as possible instead
                    of deliberate as in the previous weeks:
                  </h3>

                  <div className={styles.multy_clr_box_full_width}>
                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.bullet_remove} ${styles.yellow_bg}`}
                    >
                      <h4
                        className={`${styles.number_cont} ${styles.left_number_cont}`}
                        style={{
                          color: "#022028",
                          textShadow: "1px 1px 5px #ffea4f",
                        }}
                      >
                        01
                      </h4>
                      <h4
                        className={styles.number_cont}
                        style={{
                          color: "#022028",
                          textShadow: "1px 1px 5px #ffea4f",
                        }}
                      >
                        Begin with the{" "}
                        <span style={{ color: "#0236ad" }}>
                          Banishing Ritual of the Pentagram
                        </span>{" "}
                        to clear and align the space.
                      </h4>
                    </div>

                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.bullet_remove} ${styles.purple_bg}`}
                    >
                      <h4
                        className={`${styles.number_cont} ${styles.left_number_cont}`}
                      >
                        02
                      </h4>
                      <h4 className={styles.number_cont}>
                        Follow with the{" "}
                        <span style={{ color: "#a2ff00" }}>
                          Invoking of the Pentagrams
                        </span>{" "}
                        to summon and embody the elemental forces.
                      </h4>
                    </div>

                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.bullet_remove} ${styles.sky_bg}`}
                    >
                      <h4
                        className={`${styles.number_cont} ${styles.left_number_cont}`}
                      >
                        03
                      </h4>
                      <h4 className={styles.number_cont}>
                        Proceed directly into the Invocation of Our Divine
                        Infinite Being, delivering the pronouncement with
                        strength, reverence, and unwavering focus.
                      </h4>
                    </div>

                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.bullet_remove} ${styles.orange_bg}`}
                    >
                      <h4
                        className={`${styles.number_cont} ${styles.left_number_cont}`}
                      >
                        04
                      </h4>
                      <h4 className={styles.number_cont}>
                        Conclude with the ritual closing, sealing the work in
                        order and balance.
                      </h4>
                    </div>
                  </div>

                  <div className={styles.content_section}>
                    <p>
                      Because this is the <span>first major pronouncement</span>{" "}
                      in the cycle, and much of the ritual work to come depends
                      on the art of proper delivery, it is an ideal piece to
                      revisit often. Use it as a training ground for pronouncing
                      with both the{" "}
                      <span>
                        strength of the voice and the fullness of the heart
                      </span>
                      —a union of sound and intention that carries power into
                      the seen and unseen worlds.
                    </p>

                    <p>
                      This invocation greatly amplifies the alignment
                      established by the Grand Theurgic Invocation. In many
                      ways, it is a divine prayer offered to the cosmos—both the
                      infinite expanse above and the infinite depths within.
                      Moving forward, we recommend performing this rite at least{" "}
                      <span>once each week</span> on a day you deem sacred,
                      especially in any week when you are not engaging in other
                      major ritual work. Over time, it will become a central
                      point of return, a living act of devotion and alignment
                      that renews the bond between the Microcosm and the
                      Macrocosm.
                    </p>
                  </div>
                </div>
              </div>

              <div className={styles.orange_bar}>
                <h2>Step 10 (week 10) – Practice the Opening of the Gates</h2>
              </div>

              <div className={`${styles.blck1_main} ${styles.blck18_main}`}>
                <div className={styles.image_section}>
                  <Image src={block18} alt="Block-18 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>
                      This is a week you need to plan for, expect to spend 15
                      hours over 6 days in a row
                    </p>

                    <p>
                      This is one of the most intensive weeks of the entire
                      sequence—a <span>six-day cycle</span> designed to
                      establish your command of the elemental gates through both
                      banishing and invoking forms. The purpose here is to
                      attune the ritual field to receive the{" "}
                      <span>
                        divine intelligences of the planetary gods and the
                        zodiacal signs
                      </span>
                      , each rooted in an elemental foundation. While in later
                      work these gates will be opened to actively call those
                      intelligences, in this week the focus is on{" "}
                      <span>theory, structure, and mastery of form</span>—you
                      will close the ritual after each opening.
                    </p>
                  </div>
                  <h4 className={styles.yelow_heading}>
                    Day One – Preparation and Inscription
                  </h4>
                  <h4 className={styles.white_cont_26}>
                    Set aside a full <span>four to five hours</span> for study
                    and preparation. You havealready copied the{" "}
                    <span>Banishing Ritual of the Pentagram</span> into your
                    journal in earlier weeks; now inscribe only what is
                    necessary for the <span>Opening of the Gates</span>{" "}
                    sequence. This includes:
                  </h4>
                </div>
              </div>

              <div
                className={`${styles.blck1_main} ${styles.blck19_main} ${styles.flex_direction_reverse}`}
              >
                <div className={styles.image_section}>
                  <Image src={block19} alt="Block-19 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.multy_clr_box_full_width}>
                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.yellow_bg}`}
                    >
                      <h4
                        className={styles.number_cont}
                        style={{
                          color: "#022028",
                          textShadow: "1px 1px 5px #ffea4f",
                        }}
                      >
                        <span style={{ color: "#c0036e" }}>
                          The Invocation of Hermes and Apollo
                        </span>{" "}
                        — Hermes as the divine messenger, Apollo as the central
                        harmonizer of the spheres. Write their{" "}
                        <span style={{ color: "#c0036e" }}>
                          resonant divine names
                        </span>{" "}
                        and include a few notes from our Ritual Praxis so you
                        clearly understand their role. This syncretized god-form
                        amplifies the ritual space, preparing it for heightened
                        divinatory contact.
                      </h4>
                    </div>

                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.orange_bg}`}
                    >
                      <h4 className={styles.number_cont}>
                        <span style={{ color: "#f0ff00" }}>
                          Precise tracings for the banishing/invoking pentagrams
                          of eachelemental combination in every direction,
                        </span>{" "}
                        beginning with{" "}
                        <span style={{ color: "#f0ff00" }}>Fire</span> and
                        proceeding in the sequence:
                      </h4>

                      <div className={styles.round_blt_cont_wrpr}>
                        <h6 className={styles.round_bullet_cont}>
                          Fire of Fire
                        </h6>
                        <h6 className={styles.round_bullet_cont}>
                          Fire of Water
                        </h6>
                        <h6 className={styles.round_bullet_cont}>
                          Fire of Air
                        </h6>
                        <h6 className={styles.round_bullet_cont}>
                          Fire of Earth
                        </h6>
                        <h6 className={styles.round_bullet_cont}>
                          <span style={{ color: "#f0ff00" }}>
                            Fire of Spirit
                          </span>{" "}
                          (Spirit traced within the human frame)
                        </h6>
                      </div>
                    </div>

                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.purple_bg}`}
                    >
                      <h4 className={styles.number_cont}>
                        Repeat this same structure for each remaining element —{" "}
                        <span style={{ color: "#ffea00" }}>
                          Air, Water, Earth,
                        </span>{" "}
                        and <span style={{ color: "#ffea00" }}>Spirit</span> —
                        with Spirit itself functioning exactly like the others:
                      </h4>

                      <div className={styles.round_blt_cont_wrpr}>
                        <h6 className={styles.round_bullet_cont}>
                          Spirit of Fire
                        </h6>
                        <h6 className={styles.round_bullet_cont}>
                          Spirit of Water
                        </h6>
                        <h6 className={styles.round_bullet_cont}>
                          Spirit of Air
                        </h6>
                        <h6 className={styles.round_bullet_cont}>
                          Spirit of Earth
                        </h6>
                        <h6 className={styles.round_bullet_cont}>
                          Spirit of Spirit (Spirit traced within the human
                          frame)
                        </h6>
                      </div>
                    </div>
                  </div>

                  <div className={styles.content_section}>
                    <p>
                      Practice tracing these several times in preparation,
                      resonating the divine signature of the Demiurgos of one
                      element in all five directions (including Spirit), then
                      proceed to the next element. As you inscribe, note each
                      elemental correspondence, directional association, and the
                      function of the pentagram in regulating the elemental
                      currents of the ritual space.
                    </p>
                  </div>
                </div>
              </div>

              <div className={`${styles.blck1_main} ${styles.blck20_main}`}>
                <div className={styles.image_section}>
                  <Image src={block20} alt="Block-20 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <h4 className={styles.yelow_heading}>
                    Days Two to Six – Ritual Practice
                  </h4>

                  <p className={styles.white_cont_26}>
                    For the next{" "}
                    <span style={{ color: "#ffea00" }}>five days</span>, you
                    will perform{" "}
                    <span style={{ color: "#ffea00" }}>
                      two complete rituals per day
                    </span>
                    , beginning the first practice day with{" "}
                    <span style={{ color: "#ffea00" }}>Fire</span>:
                  </p>

                  <div className={styles.multy_clr_box_full_width}>
                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.yellow_bg}`}
                    >
                      <h4
                        className={styles.number_cont}
                        style={{
                          color: "#022028",
                          textShadow: "1px 1px 5px #ffea4f",
                        }}
                      >
                        <span style={{ color: "#c0036e" }}>Morning</span> – The
                        full banishing sequence of the gates (Banishing,
                        Hermes/Apollo, Elemental Gatework per one element).
                      </h4>
                    </div>
                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.orange_bg}`}
                    >
                      <h4 className={styles.number_cont}>
                        <span>Evening</span> – The full <span>invoking</span>{" "}
                        sequence of the gates (Banishing, Hermes/Apollo,
                        Elemental Gatework per one element).
                      </h4>
                    </div>
                  </div>

                  <h3 className={styles.sky_heading_35}>
                    Each ritual begins with:
                  </h3>

                  <div className={styles.multy_clr_box_full_width}>
                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.bullet_remove} ${styles.yellow_bg}`}
                    >
                      <h4
                        className={`${styles.number_cont} ${styles.left_number_cont}`}
                        style={{
                          color: "#022028",
                          textShadow: "1px 1px 5px #ffea4f",
                        }}
                      >
                        01
                      </h4>
                      <h4
                        className={styles.number_cont}
                        style={{
                          color: "#022028",
                          textShadow: "1px 1px 5px #ffea4f",
                        }}
                      >
                        <span style={{ color: "#033c8a" }}>
                          Banishing Ritual of the Pentagram
                        </span>{" "}
                        to establish order and clarity.
                      </h4>
                    </div>
                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.bullet_remove} ${styles.purple_bg}`}
                    >
                      <h4
                        className={`${styles.number_cont} ${styles.left_number_cont}`}
                      >
                        02
                      </h4>
                      <h4 className={styles.number_cont}>
                        <span style={{ color: "#fce20b" }}>
                          Invocation of Hermes and Apollo
                        </span>{" "}
                        — Hermes opens the pathways of divine communication;
                        Apollo holds the central harmony of the celestial
                        spheres.
                      </h4>
                    </div>
                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.bullet_remove} ${styles.sky_bg} ${styles.flex_wrpr}`}
                    >
                      <div
                        className={`${styles.width_100} ${styles.number_cont_flex}`}
                      >
                        <h4
                          className={`${styles.number_cont} ${styles.left_number_cont}`}
                        >
                          03
                        </h4>
                        <h4 className={styles.number_cont}>
                          <span style={{ color: "#fce20b" }}>
                            Full Elemental Gate Sequence,
                          </span>{" "}
                          moving slowly and deliberately through every direction
                          for the day’s chosen element. The daily order is:
                        </h4>
                      </div>

                      <div
                        className={`${styles.round_blt_cont_wrpr} ${styles.width_100}`}
                      >
                        <h6 className={styles.round_bullet_cont}>
                          <span style={{ color: "#fce20b" }}>Day 2:</span> Fire
                          of Fire Fire of Water Fire of Air Fire of Earth Fire
                          of Spirit
                        </h6>
                        <h6 className={styles.round_bullet_cont}>
                          <span style={{ color: "#fce20b" }}>Day 3:</span> Water
                          of Fire Water of Water Water of Air Water of Earth
                          Water of Spirit
                        </h6>
                        <h6 className={styles.round_bullet_cont}>
                          <span style={{ color: "#fce20b" }}>Day 4:</span> Air
                          of Fire Air of Water Air of Air Air of Earth Air of
                          Spirit
                        </h6>
                        <h6 className={styles.round_bullet_cont}>
                          <span style={{ color: "#fce20b" }}>Day 5:</span> Earth
                          of Fire Earth of Water Earth of Air Earth of Earth
                          Earth of Spirit
                        </h6>
                        <h6 className={styles.round_bullet_cont}>
                          <span style={{ color: "#fce20b" }}>Day 6:</span>{" "}
                          Spirit of Fire Spirit of Water Spirit of Air Spirit of
                          Earth Spirit of Spirit{" "}
                          <i>(all traced within the human frame)</i>
                        </h6>
                      </div>
                    </div>
                  </div>

                  <div className={styles.content_section}>
                    <p>
                      Move at a <span>measured pace</span> so that each ritual
                      lasts at least <span>one</span> hour. See each pentagram
                      ignite in the air (or in the case of Spirit, within the
                      human frame), feel its resonance fill the elemental sphere
                      it governs, and speak the divine names with clarity and
                      force, letting the sound carry through the planes.
                    </p>

                    <p>
                      By the end of this week, you will have{" "}
                      <span>invoked and banished</span> every elemental gate in
                      every direction for all five elements, with Spirit
                      functioning exactly like the others but traced within the
                      human frame. This totals{" "}
                      <span>ten complete openings and closings</span> across
                      five days of work, engraving the elemental keys into both
                      memory and subtle body, and preparing you for the{" "}
                      <span>full orchestration of the spheres</span> in the work
                      to come.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.suggested_order_page_part3}>
            <div className={styles.blck_sec_common_width}>
              <div className={styles.orange_bar}>
                <h2>Step 11 (week 11) – Planetary Invocation Training – Without the Gates</h2>
              </div>

              <div
                className={`${styles.blck1_main} ${styles.blck21_main} ${styles.flex_direction_reverse}`}
              >
                <div className={styles.image_section}>
                  <Image src={block21} alt="Block-21 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>This step requires three days with anywhere between one to two hours each</p>

                    <p>In the <span>twelve-month Inner Mystery School program</span>, the planets are invoked <span>following the Opening of the Gates</span> that correspond to their elemental roots. In a complete theurgic operation, those gates are either <span>banished</span>—to create clarity, separation, and a purely contemplative link—or <span>invoked</span>—to establish direct union with the planetary divine intelligence. In full ceremonial work, the Opening of the Gates is not optional: it is the elemental harmonization that allows the planetary god to enter without obstruction or distortion.</p>

                    <p>However, in this accelerated training week, performing the complete Opening of the Gates for all planets in sequence would be excessive—risking energetic exhaustion or even chaotic interference. For this reason, we will omit both the Pentagram ritual and Gates here, focusing instead on mastering the <span>planetary invocations themselves</span>, including their <span>concentrations, gestures, divine names, and pronouncements.</span></p>

                    <p>What you learn this week will be ready for immediate integration into full theurgic operations in the future. Once you are practiced with this form, you will be able to open the Gates, move directly into the planetary invocation, and hold the presence of the god with clarity and strength.</p>

                    <p>Rather than invoking each planet through the Gates, you will approach them in focused, meditative intervals. This method trains you in the precise vocal delivery, the embodied gestures, and the inner visualizations that will later be combined with the full elemental framework.</p>
                  </div>
                </div>
              </div>

              <div className={`${styles.blck1_main} ${styles.blck22_main}`}>
                <div className={styles.image_section}>
                  <Image src={block22} alt="Block-22 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <h3 className={styles.sky_heading}>For each planet, the procedure is as follows:</h3>

                  <div className={styles.multy_clr_box_full_width}>
                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.bullet_remove} ${styles.yellow_bg}`}
                    >
                      <h4
                        className={`${styles.number_cont} ${styles.left_number_cont}`}
                        style={{
                          color: "#022028",
                          textShadow: "1px 1px 5px #ffea4f",
                        }}
                      >
                        01
                      </h4>
                      <h4
                        className={styles.number_cont}
                        style={{
                          color: "#022028",
                          textShadow: "1px 1px 5px #ffea4f",
                        }}
                      >
                        <span style={{ color: "#c3028a" }}>Concentration</span> – With hands clasped in the planetary gesture, imagine the planet itself resting in your palms—not as a miniature sphere, but at <span style={{ color: "#c3028a" }}>full cosmic scale and weight</span>. Feel its immensity pressing into your awareness, as if the entire planet were present in the ritual space. Let its energy fill the space completely, saturating the atmosphere with its presence.
                      </h4>
                    </div>

                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.bullet_remove} ${styles.orange_bg}`}
                    >
                      <h4
                        className={`${styles.number_cont} ${styles.left_number_cont}`}
                      >
                        02
                      </h4>
                      <h4
                        className={styles.number_cont}
                      >
                        <span style={{ color: "#baff00" }}>Gesture</span> – Assume the hand posture that represents the planetary force. Each gesture is symbolic of the planet’s nature, sealing the connection through both body and mind.
                      </h4>
                    </div>

                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.bullet_remove} ${styles.purple_bg}`}
                    >
                      <h4
                        className={`${styles.number_cont} ${styles.left_number_cont}`}
                      >
                        03
                      </h4>
                      <h4
                        className={styles.number_cont}
                      >
                        <span style={{ color: "#f0ff00" }}>Divine Name</span> – While holding the gesture and maintaining the concentration, intone the divine name of the planet three times, allowing the vibration to carry through you and outward into the space.
                      </h4>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className={`${styles.blck1_main} ${styles.blck23_main} ${styles.flex_direction_reverse}`}
              >
                <div className={styles.image_section}>
                  <Image src={block23} alt="Block-23 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.multy_clr_box_full_width}>
                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.bullet_remove} ${styles.violet_bg}`}
                    >
                      <h4
                        className={`${styles.number_cont} ${styles.left_number_cont}`}
                      >
                        04
                      </h4>
                      <h4
                        className={styles.number_cont}
                      >
                        <span style={{ color: "#f0ff00" }}>Pronouncement</span> – Following the divine names, make the <span style={{ color: "#f0ff00" }}>full pronouncement</span> for the planet once, speaking it with clarity, conviction, and the alignment of heart and will.
                      </h4>
                    </div>

                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.bullet_remove} ${styles.green_bg}`}
                    >
                      <h4
                        className={`${styles.number_cont} ${styles.left_number_cont}`} style={{ color: "#000000", textShadow: "none" }}
                      >
                        05
                      </h4>
                      <h4
                        className={styles.number_cont} style={{ color: "#000000", textShadow: "none" }}
                      >
                        <span style={{ color: "#015717" }}>Rāja Meditation</span> – Remain in stillness for at least three minutes, sustaining the presence of the planetary intelligence in the space and within your own subtle body.
                      </h4>
                    </div>

                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.bullet_remove} ${styles.sky_bg}`}
                    >
                      <h4
                        className={`${styles.number_cont} ${styles.left_number_cont}`}
                      >
                        06
                      </h4>
                      <h4
                        className={styles.number_cont}
                      >
                        <span style={{ color: "#f6ff00" }}>Transition</span> – Release the gesture, let the presence settle, and then move to the next planet.
                      </h4>
                    </div>
                  </div>
                </div>
              </div>

              <div className={`${styles.blck1_main} ${styles.blck24_main}`}>
                <div className={styles.image_section}>
                  <Image src={block24} alt="Block-24 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <h4 className={styles.yelow_heading}>Preparation – Day One</h4>

                  <p className={styles.white_cont_26}>On the first day before you begin the meditation, you will focus entirely on preparing and inscribing the work into your journal. For each planet:</p>

                  <div className={styles.multy_clr_box_full_width}>
                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.yellow_bg}`}
                    >
                      <h4
                        className={styles.number_cont}
                        style={{
                          color: "#022028",
                          textShadow: "1px 1px 5px #ffea4f",
                        }}
                      >
                        Copy its <span style={{ color: "#8c0169" }}>resonant divine name.</span>
                      </h4>
                    </div>

                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.orange_bg}`}
                    >
                      <h4
                        className={styles.number_cont}
                      >
                        Copy the <span style={{ color: "#baff00" }}>full pronouncement</span> exactly as given in our Ritual Praxis. (reading in Latin and English is preferred)
                      </h4>
                    </div>

                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.purple_bg}`}
                    >
                      <h4
                        className={styles.number_cont}
                      >
                        Note the <span style={{ color: "#f0ff00" }}>gesture</span> that represents it, clearly describing the hand position and any symbolic significance
                      </h4>
                    </div>

                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.violet_bg}`}
                    >
                      <h4
                        className={styles.number_cont}
                      >
                        Write a short description of the <span style={{ color: "#b2ff00" }}>concentration</span>—how you will imagine the planet at full scale and weight in your clasped hands, and the quality of energy it radiates.
                      </h4>
                    </div>

                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.sky_bg}`}
                    >
                      <h4
                        className={styles.number_cont}
                      >
                        Add a few key notes on the planetary intelligence itself: its astrological rulership, qualities, and the nature of its influence in the theurgic current.
                      </h4>
                    </div>
                  </div>

                  <div className={styles.content_section}>
                    <p>Write all of this so that when you later combine it with the Opening of the Gates, you can open directly to these pages and move seamlessly into planetary banishing/invocation without hesitation. Once the material is written, <span style={{ color: "#ccff00" }}>practice pronouncing</span> each divine name aloud until you can speak it with confidence and resonance.</p>
                  </div>
                </div>
              </div>

              <div
                className={`${styles.blck1_main} ${styles.blck25_main} ${styles.flex_direction_reverse}`}
              >
                <div className={styles.image_section}>
                  <Image src={block25} alt="Block-25 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <h4 className={styles.yelow_heading}>Practice – Days Two and Three</h4>
                  <p className={styles.white_cont_26}>You will work with all of the planets in <span style={{ color: "#fff800" }}>two sets</span> over two days:</p>

                  <div className={styles.multy_clr_box_full_width}>
                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.yellow_bg} ${styles.flex_direction_column}`}
                    >
                      <h4
                        className={styles.number_cont} style={{ color: "#022028", textShadow: "1px 1px 5px #ffea4f" }}
                      >
                        Day Two – Inner Planets and Luminaries
                      </h4>
                      <div className={styles.sub_point_wrpr}>
                        <h6 style={{ color: "#311c8e" }}>01. Moon</h6>
                        <h6 style={{ color: "#311c8e" }}>02. Mercury</h6>
                        <h6 style={{ color: "#311c8e" }}>03. Venus</h6>
                        <h6 style={{ color: "#311c8e" }}>04. Sun</h6>
                        <h6 style={{ color: "#311c8e" }}>05. Mars</h6>
                      </div>
                    </div>

                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.orange_bg} ${styles.flex_direction_column}`}
                    >
                      <h4
                        className={styles.number_cont}
                      >
                        Day Three – Outer Planets
                      </h4>
                      <div className={styles.sub_point_wrpr}>
                        <h6>01. Jupiter</h6>
                        <h6>02. Saturn</h6>
                        <h6>03. Uranus</h6>
                        <h6>04. Neptune</h6>
                        <h6>05. Pluto</h6>
                      </div>
                    </div>
                  </div>

                  <h3 className={styles.sky_heading_35}>Procedure for Each Planet <span>(repeated exactly for all):</span></h3>

                  <div className={styles.multy_clr_box_full_width}>
                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.yellow_bg} ${styles.bullet_remove}`}
                    >
                      <h4
                        className={`${styles.number_cont} ${styles.left_number_cont}`} style={{ color: "#022028", textShadow: "1px 1px 5px #ffea4f" }}
                      >
                        01
                      </h4>
                      <h4
                        className={styles.number_cont} style={{ color: "#022028", textShadow: "1px 1px 5px #ffea4f" }}
                      >
                        Enter the <span style={{ color: "#3110a8" }}>concentration</span>, visualizing the planet at full size and mass within your hands, its presence expanding into and saturating the ritual space.
                      </h4>
                    </div>

                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.orange_bg} ${styles.bullet_remove}`}
                    >
                      <h4
                        className={`${styles.number_cont} ${styles.left_number_cont}`}
                      >
                        02
                      </h4>
                      <h4
                        className={styles.number_cont}
                      >
                        Assume the <span style={{ color: "#d2ff00" }}>planetary gesture</span>.
                      </h4>
                    </div>

                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.purple_bg} ${styles.bullet_remove}`}
                    >
                      <h4
                        className={`${styles.number_cont} ${styles.left_number_cont}`}
                      >
                        03
                      </h4>
                      <h4
                        className={styles.number_cont}
                      >
                        Intone the <span style={{ color: "#d2ff00" }}>divine name</span>three times.
                      </h4>
                    </div>

                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.violet_bg} ${styles.bullet_remove}`}
                    >
                      <h4
                        className={`${styles.number_cont} ${styles.left_number_cont}`}
                      >
                        04
                      </h4>
                      <h4
                        className={styles.number_cont}
                      >
                        Speak the <span style={{ color: "#d2ff00" }}>pronouncement</span> once, with full voice and authority.
                      </h4>
                    </div>

                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.sky_bg} ${styles.bullet_remove}`}
                    >
                      <h4
                        className={`${styles.number_cont} ${styles.left_number_cont}`}
                      >
                        05
                      </h4>
                      <h4
                        className={styles.number_cont}
                      >
                        Sit in <span style={{ color: "#d2ff00" }}>Rāja meditation</span> for at least three minutes, attuning to the presence and influence of the planetary god.
                      </h4>
                    </div>

                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.green_bg} ${styles.bullet_remove}`}
                    >
                      <h4
                        className={`${styles.number_cont} ${styles.left_number_cont}`} style={{ color: "#022028", textShadow: "1px 1px 5px #ffea4f" }}
                      >
                        06
                      </h4>
                      <h4
                        className={styles.number_cont} style={{ color: "#022028", textShadow: "1px 1px 5px #ffea4f" }}
                      >
                        Move to the next planet.
                      </h4>
                    </div>
                  </div>
                </div>
              </div>

              <div className={`${styles.blck1_main} ${styles.blck26_main}`}>
                <div className={styles.image_section}>
                  <Image src={block26} alt="Block-26 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>This pacing will require <span>an hour or more</span> each day. Do not rush. Allow the presence of each planetary god to fill the full meditation period before proceeding.</p>

                    <p>While this week’s work omits the Opening of the Gates, it should be clearly understood that in <span>complete theurgic practice</span>, the Gates are essential. They form the elemental architecture through which the planetary intelligences are safely and clearly received.</p>
                  </div>

                  <h4 className={styles.yelow_heading}>What you gain in this week is <span style={{ color: "#c1ff00" }}>precision, embodiment, and presence:</span></h4>

                  <div className={styles.multy_clr_box_full_width}>
                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.yellow_bg}`}
                    >
                      <h4
                        className={styles.number_cont}
                        style={{
                          color: "#022028",
                          textShadow: "1px 1px 5px #ffea4f",
                        }}
                      >
                        The ability to deliver divine names with resonance and authority.
                      </h4>
                    </div>

                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.orange_bg}`}
                    >
                      <h4
                        className={styles.number_cont}
                      >
                        The skill of holding a planetary presence in both visualization and bodily gesture.
                      </h4>
                    </div>

                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.purple_bg}`}
                    >
                      <h4
                        className={styles.number_cont}
                      >
                        The meditative depth to remain still in the god’s presence without dispersing attention.
                      </h4>
                    </div>
                  </div>

                  <div className={styles.content_section}>
                    <p>By the end of this week, you will have a living familiarity with each planetary intelligence and the vocal, imaginal, and physical keys to call them. When you later combine this with the Opening of the Gates, your invocations will enter a higher order of clarity, potency, and alignment.</p>
                  </div>
                </div>
              </div>

              <div className={styles.orange_bar}>
                <h2>Step 12 (week 12) – Zodiacal Invocation Training – Without the Gates</h2>
              </div>

              <div
                className={`${styles.blck1_main} ${styles.blck27_main} ${styles.flex_direction_reverse}`}
              >
                <div className={styles.image_section}>
                  <Image src={block27} alt="Block-27 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>This step requires four days with anywhere between one to two hours eachOnce again as with the planets, in the <span>twelve-month Inner Mystery School program</span>, the zodiacal signs are invoked alongside the planets in full theurgic operations. When performed in that context, the <span>Opening of the Gates</span> is used first to establish elemental harmony before the invocation, ensuring the sign’s intelligence can enter with clarity and precision.</p>

                    <p>For this week’s training, however, we will focus solely on the <span>core vocal and gestural components</span> of the zodiacal invocations, without the elemental Gates. This will allow you to learn the <span>divine names, pronouncements,</span> and <span>gestures</span> of all twelve signs in a clear, methodical way—ready to be added into full ritual structure in future work.</p>

                    <p>Unlike the planetary invocations, <span>no concentration step is used</span> here; the focus is entirely on gesture, voice, and meditative presence.</p>
                  </div>

                  <h3 className={styles.sky_heading_35}>Structure of the Work</h3>

                  <h4 className={styles.yelow_heading}>The method is the same as with the planets:</h4>

                  <div className={styles.multy_clr_box_full_width}>
                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.yellow_bg} ${styles.bullet_remove}`}
                    >
                      <h4
                        className={`${styles.number_cont} ${styles.left_number_cont}`} style={{ color: "#022028", textShadow: "1px 1px 5px #ffea4f" }}
                      >
                        01
                      </h4>
                      <h4
                        className={styles.number_cont} style={{ color: "#022028", textShadow: "1px 1px 5px #ffea4f" }}
                      >
                        Assume the <span style={{ color: "#b30086" }}>hand gesture</span> for the modality associated with the sign (Cardinal/Fixed/Mutable).
                      </h4>
                    </div>

                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.orange_bg} ${styles.bullet_remove}`}
                    >
                      <h4
                        className={`${styles.number_cont} ${styles.left_number_cont}`}
                      >
                        02
                      </h4>
                      <h4
                        className={styles.number_cont}
                      >
                        Intone the <span style={{ color: "#d8ff00" }}>divine name</span> three times.
                      </h4>
                    </div>

                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.purple_bg} ${styles.bullet_remove}`}
                    >
                      <h4
                        className={`${styles.number_cont} ${styles.left_number_cont}`}
                      >
                        03
                      </h4>
                      <h4
                        className={styles.number_cont}
                      >
                        Speak the <span style={{ color: "#d2ff00" }}>pronouncement</span> once, with precision and strength of voice.
                      </h4>
                    </div>

                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.violet_bg} ${styles.bullet_remove}`}
                    >
                      <h4
                        className={`${styles.number_cont} ${styles.left_number_cont}`}
                      >
                        04
                      </h4>
                      <h4
                        className={styles.number_cont}
                      >
                        Sit in <span style={{ color: "#e4ff00" }}>Rāja meditation</span> for at least <span style={{ color: "#e4ff00" }}>three minutes</span>, attuning to the presence of the sign’s intelligence before moving on.
                      </h4>
                    </div>
                  </div>
                </div>
              </div>

              <div className={`${styles.blck1_main} ${styles.blck28_main}`}>
                <div className={styles.image_section}>
                  <Image src={block28} alt="Block-28 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <h4 className={styles.yelow_heading}>Preparation – Day One</h4>

                  <p className={styles.white_cont_26}>On the first day, prepare your <span style={{ color: "#a8ff00" }}>journal reference</span> for the zodiacal work:</p>

                  <div className={styles.multy_clr_box_full_width}>
                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.yellow_bg}`}
                    >
                      <h4
                        className={styles.number_cont}
                        style={{
                          color: "#022028",
                          textShadow: "1px 1px 5px #ffea4f",
                        }}
                      >
                        Copy the <span style={{ color: "#a1027a" }}>resonant divine name</span> for each sign.
                      </h4>
                    </div>

                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.orange_bg}`}
                    >
                      <h4
                        className={styles.number_cont}
                      >
                        Copy the <span style={{ color: "#f6ff00" }}>full pronouncement</span> exactly as given in our Ritual Praxis (reading in Latin and English is preferred).
                      </h4>
                    </div>

                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.purple_bg}`}
                    >
                      <h4
                        className={styles.number_cont}
                      >
                        Note the <span style={{ color: "#b4ff00" }}>hand gesture</span> that represents the sign, clearly describing its form and symbolic meaning.
                      </h4>
                    </div>

                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.sky_bg}`}
                    >
                      <h4
                        className={styles.number_cont}
                      >
                        Include a few brief notes on the sign’s astrological nature, elemental quality (Fire, Water, Air, or Earth), and modality (Cardinal, Fixed, or Mutable).
                      </h4>
                    </div>
                  </div>

                  <div className={styles.content_section}>
                    <p>Once this is complete, practice speaking each divine name aloud until you can deliver it with clarity, stability, and resonance.</p>
                  </div>

                  <h4 className={styles.yelow_heading}>Practice – Days Two, Three, and Four</h4>

                  <p className={styles.white_cont_26}>Over the next three days, you will work through the signs grouped by <span style={{ color: "#a8ff00" }}>modality</span>:</p>

                  <div className={styles.multy_clr_box_full_width}>
                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.yellow_bg} ${styles.flex_direction_column}`}
                    >
                      <h4
                        className={styles.number_cont} style={{ color: "#022028", textShadow: "1px 1px 5px #ffea4f" }}
                      >
                        Day Two – Cardinal Signs
                      </h4>
                      <div className={styles.sub_point_wrpr}>
                        <h6 style={{ color: "#311c8e" }}>01. Aries</h6>
                        <h6 style={{ color: "#311c8e" }}>02. Cancer</h6>
                        <h6 style={{ color: "#311c8e" }}>03. Libra</h6>
                        <h6 style={{ color: "#311c8e" }}>04. Capricorn</h6>
                      </div>
                    </div>

                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.orange_bg} ${styles.flex_direction_column}`}
                    >
                      <h4
                        className={styles.number_cont}
                      >
                        Day Three – Fixed Signs
                      </h4>
                      <div className={styles.sub_point_wrpr}>
                        <h6>01. Taurus</h6>
                        <h6>02. Leo</h6>
                        <h6>03. Scorpio</h6>
                        <h6>04. Aquarius</h6>
                      </div>
                    </div>

                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.purple_bg} ${styles.flex_direction_column}`}
                    >
                      <h4
                        className={styles.number_cont}
                      >
                        Day Four – Mutable Signs
                      </h4>
                      <div className={styles.sub_point_wrpr}>
                        <h6>01. Gemini</h6>
                        <h6>02. Virgo</h6>
                        <h6>03. Sagittarius</h6>
                        <h6>04. Pisces</h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className={`${styles.blck1_main} ${styles.blck29_main} ${styles.flex_direction_reverse}`}
              >
                <div className={styles.image_section}>
                  <Image src={block29} alt="Block-29 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <h3 className={styles.sky_heading_35}>Procedure for Each Sign (repeat exactly for all twelve):</h3>

                  <div className={styles.multy_clr_box_full_width}>
                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.yellow_bg} ${styles.bullet_remove}`}
                    >
                      <h4
                        className={`${styles.number_cont} ${styles.left_number_cont}`} style={{ color: "#022028", textShadow: "1px 1px 5px #ffea4f" }}
                      >
                        01
                      </h4>
                      <h4
                        className={styles.number_cont} style={{ color: "#022028", textShadow: "1px 1px 5px #ffea4f" }}
                      >
                        Assume the <span style={{ color: "#af0a89" }}>zodiacal gesture</span> of their modality.
                      </h4>
                    </div>

                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.orange_bg} ${styles.bullet_remove}`}
                    >
                      <h4
                        className={`${styles.number_cont} ${styles.left_number_cont}`}
                      >
                        02
                      </h4>
                      <h4
                        className={styles.number_cont}
                      >
                        Intone the <span style={{ color: "#d8ff00" }}>divine name</span> three times.
                      </h4>
                    </div>

                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.purple_bg} ${styles.bullet_remove}`}
                    >
                      <h4
                        className={`${styles.number_cont} ${styles.left_number_cont}`}
                      >
                        03
                      </h4>
                      <h4
                        className={styles.number_cont}
                      >
                        Speak the <span style={{ color: "#f0ff00" }}>pronouncement</span> once, with full voice and authority.
                      </h4>
                    </div>

                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.violet_bg} ${styles.bullet_remove}`}
                    >
                      <h4
                        className={`${styles.number_cont} ${styles.left_number_cont}`}
                      >
                        04
                      </h4>
                      <h4
                        className={styles.number_cont}
                      >
                        Sit in <span style={{ color: "#ccff00" }}>Rāja meditation</span> for at least three minutes, holding the presence of the sign’s intelligence in your awareness.
                      </h4>
                    </div>
                  </div>

                  <div className={styles.content_section}>
                    <p>Allow at least <span>an hour each day</span> for this work, giving every sign the full three-minute period before moving to the next.</p>

                    <p>While this week’s work omits the Ritual of the Pentagram and the Opening of the Gates, remember that in full theurgical practice, the Gates provide the elemental foundation that makes zodiacal invocation fully effective. This training focuses on mastering the gesture, voice, and meditative receptivity that will later be combined with the elemental framework.</p>
                  </div>

                  <h4 className={styles.yelow_heading}>By the end of these three days, you will:</h4>

                  <div className={styles.multy_clr_box_full_width}>
                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.yellow_bg}`}
                    >
                      <h4
                        className={styles.number_cont} style={{ color: "#022028", textShadow: "1px 1px 5px #ffea4f" }}
                      >
                        Know all twelve zodiacal divine names and pronouncements.
                      </h4>
                    </div>

                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.orange_bg}`}
                    >
                      <h4
                        className={styles.number_cont}
                      >
                        Be able to perform their gestures with accuracy and symbolic understanding.
                      </h4>
                    </div>

                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.purple_bg}`}
                    >
                      <h4
                        className={styles.number_cont}
                      >
                        Have a direct meditative familiarity with each sign’s presence and quality.
                      </h4>
                    </div>
                  </div>

                  <div className={styles.content_section}>
                    <p>When combined with the Opening of the Gates in the future, these skills will allow you to move from elemental harmony directly into zodiacal contact, integrating the signs seamlessly into planetary and full-sphere theurgical operations.</p>
                  </div>

                  <h4 className={styles.yelow_heading}>Interval - Inner Mystery Curriculum is engaged</h4>

                  <div className={styles.content_section}>
                    <p>At this point, it must be understood that the <span>Inner Mystery School Curriculum</span>—which encompasses the final twelve months of the full Initiatory Protocol—is private and accessible only through the Backoffice of <a href="https://www.divineinfinitebeing.com/">www.DivineInfiniteBeing.com</a>. This access is granted before entering <span>Step Thirteen.</span></p>
                  </div>

                  <p className={styles.white_cont}>For those who do not undertake the full Inner Mystery work, we still strongly encourage the completion and sustained practice of the first twelve steps before moving on to Step Thirteen and beyond. These steps are not meant to be hurried; their power unfolds over time. Dedicating a season or more to living with these practices ensures that your foundation is firm, your relationship to the work is authentic, and that the more advanced phases are entered with clarity, readiness, and depth.</p>
                </div>
              </div>

              <div className={styles.orange_bar}>
                <h2>Step 13 – Culmination of the Foundational Cycle – The Natal Blueprint Invocation</h2>
              </div>

              <div className={`${styles.blck1_main} ${styles.blck30_main}`}>
                <div className={styles.image_section}>
                  <Image src={block30} alt="Block-30 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>This step marks the culmination of the foundational cycle — the point at which all the planetary and zodiacal forces you have awakened are gathered into <span>alignment with the singular pattern of your own incarnation</span>. Here, our Mystery School tradition teaches you not only to work with the gods of the heavens and the signs of the celestial wheel, but to anchor them into your own divine architecture — your oikeios daimon, the immortal pattern through which you entered this life.</p>

                    <p>In this rite, you move from working with planetary and zodiacal powers in their abstract celestial stations to working with them in <span>the exact configuration they occupied at the moment of your birth</span>. This is your cosmic seal — the living blueprint impressed into both your soul and body. By ritually invoking this pattern, you are not merely contemplating your natal chart — you are reawakening it as a theurgical engine within yourself.</p>
                  </div>

                  <h4 className={styles.yelow_heading}>Preparation – Constructing Your Personal Invocation</h4>

                  <p className={styles.white_cont}>Over the course of at least a week of preparatory work prior to your birthday, dedicate yourself to a deep study of your natal chart, and consider getting a solar return reading from a professional astrologer. Copy the chart by hand into your journal, along with its <span>full ritual invocation</span> — a sequence designed to call forth every planetary and zodiacal current <span>in its actual placement at your birth</span>. This includes:</p>

                  <div className={styles.multy_clr_box_full_width}>
                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.yellow_bg}`}
                    >
                      <h4
                        className={styles.number_cont}
                        style={{
                          color: "#022028",
                          textShadow: "1px 1px 5px #ffea4f",
                        }}
                      >
                        Each planet in the sign it occupied at your birth.
                      </h4>
                    </div>

                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.orange_bg}`}
                    >
                      <h4
                        className={styles.number_cont}
                      >
                        Your rising sign (Ascendant) and its planetary ruler.
                      </h4>
                    </div>

                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.purple_bg}`}
                    >
                      <h4
                        className={styles.number_cont}
                      >
                        The ruler of the house planet.
                      </h4>
                    </div>

                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.violet_bg}`}
                    >
                      <h4
                        className={styles.number_cont}
                      >
                        <span style={{ color: "#fcff00" }}>Optional for advanced practitioners</span> — the prime dignities and the full placement of all active transits at the time of working. (this will more than double time and dedication to this rite, but for those that are into it, go for it)
                      </h4>
                    </div>
                  </div>

                  <div className={styles.content_section}>
                    <p>Write these invocations in a form that allows you to perform them fluently from your journal, referencing each planet and sign in its exact natal context. At this point you already have all of the invocations and pronouncements, but as part of the dedication rewrite them in the order of invocation for your nativity as a spiritual exercise. </p>
                  </div>

                  <h4 className={styles.yelow_heading}>Timing and Operational Window</h4>

                  <p className={styles.white_cont}>Your operational window for this rite is precise. <span>Begin on your birthday</span> — the annual solar return, when the Sun once again occupies the exact degree it held at your birth — and complete the work before the Sun enters the next sign. This short period is a <span>charged liminal time</span> in which the cosmic pattern of your incarnation is most accessible. During these days, your alignment with it can be renewed and empowered for the year ahead.</p>
                </div>
              </div>

              <div
                className={`${styles.blck1_main} ${styles.blck31_main} ${styles.flex_direction_reverse}`}
              >
                <div className={styles.image_section}>
                  <Image src={block31} alt="Block-31 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <h3 className={styles.sky_heading_35}>The Ritual Sequence</h3>

                  <p className={styles.white_cont_26}>This is a <span style={{ color: "#00deff" }}>multi-day working</span>, performed in the following order:</p>

                  <div className={styles.multy_clr_box_full_width}>
                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.yellow_bg} ${styles.bullet_remove}`}
                    >
                      <h4
                        className={`${styles.number_cont} ${styles.left_number_cont}`} style={{ color: "#022028", textShadow: "1px 1px 5px #ffea4f" }}
                      >
                        01
                      </h4>
                      <h4
                        className={styles.number_cont} style={{ color: "#022028", textShadow: "1px 1px 5px #ffea4f" }}
                      >
                        <span style={{ color: "#bc188f" }}>Day One</span> — Begin with the invocation of your <span style={{ color: "#bc188f" }}>Sun sign and Ascendant.</span>
                      </h4>
                    </div>

                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.orange_bg} ${styles.bullet_remove}`}
                    >
                      <h4
                        className={`${styles.number_cont} ${styles.left_number_cont}`}
                      >
                        02
                      </h4>
                      <h4
                        className={styles.number_cont}
                      >
                        <span style={{ color: "#c8ff00" }}>Day two</span> - Invoke the ruler of the house planet.
                      </h4>
                    </div>

                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.purple_bg} ${styles.bullet_remove}`}
                    >
                      <h4
                        className={`${styles.number_cont} ${styles.left_number_cont}`}
                      >
                        03
                      </h4>
                      <h4
                        className={styles.number_cont}
                      >
                        <span style={{ color: "#fffc00" }}>Subsequent Days</span> — Invoke each planet in turn, in its natal sign and placement from Mercury out to Pluto.
                      </h4>
                    </div>
                  </div>

                  <div className={styles.content_section}>
                    <p>You will begin each day’s rite with <span>The Theurgic Ritual of the Pentagram</span>, including the <span>Opening of the Gates</span>, and then proceed to the invocations for that day’s designated placements. Each day’s work is treated as a complete, stand-alone ritual—banishing, opening, invocation, and closing—so that the cycle unfolds step by step, each session bringing a new facet of your natal pattern into conscious alignment.</p>
                  </div>

                  <h4 className={styles.yelow_heading}>The Effect of the Rite</h4>

                  <p className={styles.white_cont}>The invocation sequence weaves together the planetary gods in their natal positions, the zodiacal signs they inhabited, the aspects they formed (if including), and the planetary ruler of the house. Performed faithfully, it recreates the heavens as they were when your soul entered this embodiment.</p>

                  <h4 className={styles.yelow_heading}>This step gathers the entire body of your prior work into a single act:</h4>

                  <div className={styles.multy_clr_box_full_width}>
                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.yellow_bg}`}
                    >
                      <h4
                        className={styles.number_cont} style={{ color: "#022028", textShadow: "1px 1px 5px #ffea4f" }}
                      >
                        The <span style={{ color: "#b8028a" }}>planetary banishings and invocations</span> ensure that each god is personally known to you and responds to your call.
                      </h4>
                    </div>

                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.orange_bg}`}
                    >
                      <h4
                        className={styles.number_cont}
                      >
                        The <span>zodiacal invocations</span> ensure you move within the structural rhythms that give those gods their stage and timing.
                      </h4>
                    </div>

                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.purple_bg}`}
                    >
                      <h4
                        className={styles.number_cont}
                      >
                        The <span>Opening of the Gates</span> work ensures that, when used in ongoing practice, the channels for these powers are clear and direct.
                      </h4>
                    </div>
                  </div>

                  <p className={styles.white_cont}>With all these currents gathered into the singular pattern of your nativity, <span>you achieve a complete activation of your living cosmic blueprint</span> — and we suggest undertaking this at least once in your life, though performing it yearly serves as a re-consecration of your place within the great order.</p>
                </div>
              </div>

              <div className={styles.orange_bar}>
                <h2>Step 14 – Entering the Ongoing Rhythm of Theurgic Life</h2>
              </div>

              <div className={`${styles.blck1_main} ${styles.blck32_main}`}>
                <div className={styles.image_section}>
                  <Image src={block32} alt="Block-32 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>At this point in your training, you are ready to step fully into the <span>living current of theurgic practice</span> — where all the disciplines you have learned become an unbroken rhythm of conscious dialogue with the gods through the movements of the heavens. You now have the tools to work with <span>Divine Timing</span> in real time, invoking the planetary powers when their influence is to be magnified, and banishing or balancing them when their force needs moderation.</p>

                    <p>From here, astrology is no longer a passive act of observation — it is an active, ritual partnership with the gods of the spheres. The sky becomes a living script, and you have learned how to read its lines and respond with precision.</p>
                  </div>

                  <h3 className={styles.sky_heading_35}>Two Streams of Ongoing Practice</h3>

                  <div className={styles.multy_clr_box_full_width}>
                    <div className={`${styles.bullet_cont_box} ${styles.yellow_bg}`}>
                      <div className={`${styles.flex_section} ${styles.bullet_remove}`}>
                        <h4
                          className={`${styles.number_cont} ${styles.left_number_cont}`} style={{ color: "#022028", textShadow: "1px 1px 5px #ffea4f" }}
                        >
                          01
                        </h4>
                        <h4
                          className={styles.number_cont} style={{ color: "#022028", textShadow: "1px 1px 5px #ffea4f" }}
                        >
                          Alignment with the Living Sky
                        </h4>
                      </div>
                      <div className={styles.sub_bullet_section}>
                        <h4
                          className={styles.number_cont} style={{ color: "#022028", textShadow: "1px 1px 5px #ffea4f" }}
                        >
                          See the current planetary motions as the gestures of the gods, an unceasing cosmic liturgy.
                        </h4>

                        <h4
                          className={styles.number_cont} style={{ color: "#022028", textShadow: "1px 1px 5px #ffea4f" }}
                        >
                          Respond to these moments with ritual action — planetary invocations, zodiacal attunements, offerings — bringing your life into harmony  with the powers presently ruling the heavens.
                        </h4>

                        <h4
                          className={styles.number_cont} style={{ color: "#022028", textShadow: "1px 1px 5px #ffea4f" }}
                        >
                          Keep your inner rhythm aligned with the celestial clockwork, ensuring your actions move with the same currents that shape the unfolding order of the cosmos.
                        </h4>
                      </div>
                    </div>

                    <div className={`${styles.bullet_cont_box} ${styles.orange_bg}`}>
                      <div className={`${styles.flex_section} ${styles.bullet_remove}`}>
                        <h4 className={`${styles.number_cont} ${styles.left_number_cont}`}>
                          02
                        </h4>
                        <h4 className={styles.number_cont}>
                          Theurgical Divination and Manifestation
                        </h4>
                      </div>
                      <div className={styles.sub_bullet_section}>
                        <h4 className={styles.number_cont}>
                          Choose precise moments when the planetary architecture already inclines toward a desired outcome, and perform rituals to step into the world-line where that outcome is already in motion.
                        </h4>

                        <h4
                          className={styles.number_cont}
                        >
                          Apply this art to every domain of life — resolving conflicts, initiating new works, securing resources, or deepening spiritual attainment.
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className={`${styles.blck1_main} ${styles.blck33_main} ${styles.flex_direction_reverse}`}
              >
                <div className={styles.image_section}>
                  <Image src={block33} alt="Block-33 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.multy_clr_box_full_width}>
                    <div className={`${styles.bullet_cont_box} ${styles.purple_bg}`}>
                      <div className={`${styles.flex_section} ${styles.bullet_remove}`}>
                        <h4 className={`${styles.number_cont} ${styles.left_number_cont}`}>
                          03
                        </h4>
                        <h4 className={styles.number_cont}>
                          Living in Divine Timing
                        </h4>
                      </div>
                      <h4 className={styles.yelow_heading}>Your life as a ritual theurgist now flows in multiple cycles:</h4>
                      <div className={styles.sub_bullet_section}>
                        <h4 className={styles.number_cont}>
                          <span style={{ color: "#e8ff00" }}>Daily</span> — Quick banishings, elemental openings, or focused invocations in response to fast-moving transits and lunar phases.
                        </h4>

                        <h4 className={styles.number_cont}>
                          <span style={{ color: "#e8ff00" }}>Weekly to Monthly</span> — Targeted operations timed to major planetary aspects, ingressions, or lunations. Mixing between transit amplification and divinatory manifest rites.
                        </h4>

                        <h4 className={styles.number_cont}>
                          <span style={{ color: "#e8ff00" }}>Yearly</span> — The re-consecration of your natal blueprint, aligning your life to its original cosmic seal and weaving long-term intentions into the year ahead.

                        </h4>
                      </div>
                    </div>
                  </div>

                  <div className={styles.content_section}>
                    <p>The more consistently you work in this continual dialogue with the heavens, the more the pattern will reveal itself — opportunities, encounters, and inner transformations that directly reflect the precision and timing of your ritual actions.</p>

                    <p>From this moment onward, you are no longer simply completing a course — you are participating in the <span>ongoing creation of the cosmos</span>. You move with the gods, shaping the weave from within, invoking when the heavens open the way, and banishing when the currents must be steadied. This is the true rhythm of the theurgic life: <span>breath and geometry, prayer and precision, forever joined.</span></p>
                  </div>
                </div>
              </div>

              <div className={`${styles.blck1_main} ${styles.blck34_main}`}>
                <div className={styles.image_section}>
                  <Image src={block34} alt="Block-34 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <h4 className={styles.yelow_heading}>A Practical Case Scenario – Living the Theurgic Life in Real Time</h4>

                  <div className={styles.content_section}>
                    <p>Let us take the example of a fictional graduate and theurgist, <span>Anastasia</span>, a graduate of the Fifteen-Month Inner Mystery Program who has now entered the <span>continual work of a ritual theurgist</span>. She works a full-time job, has family commitments, and still wants to live in conscious alignment with the gods every single day.</p>

                    <p>Now, it must be understood that this example accounts <span>only for the direct work itself</span> — the hands-on practice and ritual praxis — not the additional time spent reading, watching trainings, studying astrology, throwing tarot, preparing charts, journaling, or engaging in the other vital activities that enrich a theurgist’s life.</p>

                    <p>What is shown here is the <span>core engine</span> of the work: the repeated, intentional acts that generate real alignment with the divine order. Even without counting the hours of study or the contemplation that naturally surrounds them, this schedule alone is more than sufficient to engage deeply with the path, immerse the practitioner in its living current, and produce the sustained contact with divine intelligences that defines a truly theurgic life.</p>
                  </div>

                  <h4 className={styles.yelow_heading}>At first glance, the scope of her practices might look intimidating:</h4>

                  <div className={styles.multy_clr_box_full_width}>
                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.yellow_bg}`}
                    >
                      <h4
                        className={styles.number_cont} style={{ color: "#022028", textShadow: "1px 1px 5px #ffea4f" }}
                      >
                        <span style={{ color: "#bc188f" }}>Daily Banishing Ritual of the Pentagram</span>
                      </h4>
                    </div>

                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.orange_bg}`}
                    >
                      <h4
                        className={styles.number_cont}
                      >
                        <span style={{ color: "#c8ff00" }}>Kriya Kundalini Yoga</span> most days
                      </h4>
                    </div>

                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.purple_bg}`}
                    >
                      <h4
                        className={styles.number_cont}
                      >
                        <span style={{ color: "#fffc00" }}>Raja Yoga</span> several times a week
                      </h4>
                    </div>

                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.sky_bg}`}
                    >
                      <h4
                        className={styles.number_cont}
                      >
                        <span style={{ color: "#fffc00" }}>Chakra Embodiment</span> at least weekly through all seven centers
                      </h4>
                    </div>

                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.green_bg}`}
                    >
                      <h4
                        className={styles.number_cont}
                      >
                        <span style={{ color: "#fffc00" }}>Invocation of Our Divine Infinite Being</span> weekly
                      </h4>
                    </div>

                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.yellow_bg}`}
                    >
                      <h4
                        className={styles.number_cont} style={{ color: "#022028", textShadow: "1px 1px 5px #ffea4f" }}
                      >
                        <span style={{ color: "#bc188f" }}>Major Planetary and Zodiacal Operation</span> monthly
                      </h4>
                    </div>
                  </div>

                  <p className={styles.white_cont}>The key is that <span>the rhythm of the work is organized</span> — each element has its place, and they reinforce one another rather than compete for time.</p>
                </div>
              </div>

              <div
                className={`${styles.blck1_main} ${styles.blck35_main} ${styles.flex_direction_reverse}`}
              >
                <div className={styles.image_section}>
                  <Image src={block35} alt="Block-35 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <h4 className={styles.yelow_heading}>Weekly Flow – How Anastasia Lives the Work Daily</h4>

                  <div className={styles.multy_clr_box_full_width}>
                    <div className={`${styles.bullet_cont_box} ${styles.yellow_bg}`}>
                      <div className={`${styles.flex_section}`}>
                        <h4 className={styles.number_cont}>
                          <span style={{ color: "#ad0285" }}>Morning Banishing Ritual of the Pentagram – 20 minutes</span>
                        </h4>
                      </div>
                      <div className={styles.padding_left}>
                        <p className={styles.white_cont} style={{ color: "#000000" }}>She rises a little earlier than she once did. Before breakfast or checking her phone, she stands in her ritual space and clears the field. This 20-minute daily practice not only creates a consecrated environment for the day but also serves as a mental reset, aligning her with the divine order before she interacts with the outer world.</p>
                      </div>
                    </div>

                    <div className={`${styles.bullet_cont_box} ${styles.orange_bg}`}>
                      <div className={`${styles.flex_section}`}>
                        <h4 className={styles.number_cont}>
                          <span style={{ color: "#ccff00" }}>Kriya Kundalini Yoga – 30 minutes, 4–5 days a week</span>
                        </h4>
                      </div>
                      <div className={styles.padding_left}>
                        <p className={styles.white_cont} style={{ color: "#ffffff" }}>On most mornings, immediately after banishing, she moves into Kriya practice. This awakens the spine, opens the channels of life-force, and sets her entire energy body humming. The days she doesn’t do Kriya, she uses the time for extra stillness in Raja Yoga.</p>
                      </div>
                    </div>
                  </div>

                  <h4 className={styles.yelow_heading}>Three to Four Times a Week</h4>

                  <div className={styles.multy_clr_box_full_width}>
                    <div className={`${styles.bullet_cont_box} ${styles.yellow_bg}`}>
                      <div className={`${styles.flex_section}`}>
                        <h4 className={styles.number_cont}>
                          <span style={{ color: "#ad0285" }}>Raja Yoga – 15 minutes</span>
                        </h4>
                      </div>
                      <div className={styles.padding_left}>
                        <p className={styles.white_cont} style={{ color: "#000000" }}>Raja is woven in as a mid-day or evening practice, a way to <span style={{ color: "#ad0285" }}>drop into sovereign awareness</span> after the day’s activity. The short, focused sessions remind her that the center of all her operations is not motion, but stillness.</p>
                      </div>
                    </div>
                  </div>

                  <h4 className={styles.yelow_heading}>Weekly</h4>

                  <div className={styles.multy_clr_box_full_width}>
                    <div className={`${styles.bullet_cont_box} ${styles.yellow_bg}`}>
                      <div className={`${styles.flex_section}`}>
                        <h4 className={styles.number_cont}>
                          <span style={{ color: "#ad0285" }}>Chakra Embodiment – 30 minutes</span>
                        </h4>
                      </div>
                      <div className={styles.padding_left}>
                        <p className={styles.white_cont} style={{ color: "#000000" }}>Once a week (usually on Sunday evening), Anastasia works through all seven chakras using the Tantric Kundalini embodiment sequence. This keeps her energy centers tuned and prevents stagnation.</p>
                      </div>
                    </div>

                    <div className={`${styles.bullet_cont_box} ${styles.orange_bg}`}>
                      <div className={`${styles.flex_section}`}>
                        <h4 className={styles.number_cont}>
                          <span style={{ color: "#ccff00" }}>Invocation of Our Divine Infinite Being – 30 minutes</span>
                        </h4>
                      </div>
                      <div className={styles.padding_left}>
                        <p className={styles.white_cont} style={{ color: "#ffffff" }}>This is done once a week, often integrated with the Invoking Pentagram Ritual. It’s her direct alignment with the ineffable Source — the wellspring from which all other divine powers flow.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className={styles.blck36_main}>
                <h3 className={styles.sky_heading_35} style={{ fontWeight: "700", margin: "0" }}>Time Commitment – The Reality</h3>
                <h4 className={styles.yelow_heading}>When broken down across her schedule, the total weekly time looks like this:</h4>

                <div className={styles.table_section_main}>
                  <div className={styles.table_container}>
                    <table>
                      <thead>
                        <tr>
                          <th>Practice</th>
                          <th>Frequency</th>
                          <th>Time Each</th>
                          <th>Total Time/Week</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Banishing Ritual</td>
                          <td>Daily (7x)</td>
                          <td>20 min</td>
                          <td className={styles.green_text}>140 min (2 hrs 20 min)</td>
                        </tr>
                        <tr>
                          <td>Kriya Kundalini</td>
                          <td>4–5x/week</td>
                          <td>30 min</td>
                          <td className={styles.green_text}>~135 min (2 hrs 15 min)</td>
                        </tr>
                        <tr>
                          <td>Raja Yoga</td>
                          <td>3–4x/week</td>
                          <td>15 min</td>
                          <td className={styles.green_text}>~60 min (1 hr)</td>
                        </tr>
                        <tr>
                          <td>Chakra Embodiment</td>
                          <td>1x/week</td>
                          <td>30 min</td>
                          <td className={styles.green_text}>30 min</td>
                        </tr>
                        <tr>
                          <td>Invocation of Our Divine Infinite Being</td>
                          <td>1x/week</td>
                          <td>30 min</td>
                          <td className={styles.green_text}>30 min</td>
                        </tr>
                        <tr>
                          <td>Monthly Operation</td>
                          <td>1x/month</td>
                          <td>~90 min</td>
                          <td className={styles.green_text}>~20 min/week average</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div className={`${styles.blck1_main} ${styles.blck37_main}`}>
                <div className={styles.image_section}>
                  <Image src={block37} alt="Block-37 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <h4 className={styles.yelow_heading}>When broken down across her schedule, the total weekly time looks like this:</h4>

                  <p className={styles.white_cont_26}>That’s roughly <span>1 hour a day</span>, with the monthly operation adding a small bump.</p>

                  <p className={styles.white_cont_26}>Because Anastasia follows the Mystery School’s <span>order of practice</span>, each ritual supports the others:</p>

                  <div className={styles.multy_clr_box_full_width}>
                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.yellow_bg}`}
                    >
                      <h4
                        className={styles.number_cont} style={{ color: "#022028", textShadow: "1px 1px 5px #ffea4f" }}
                      >
                        Daily banishing keeps her ritual space energetically clean and sharply tuned.
                      </h4>
                    </div>

                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.orange_bg}`}
                    >
                      <h4
                        className={styles.number_cont}
                      >
                        Kriya and Raja balance <span style={{ color: "#aeff00" }}>active energy movement with stillness and mental clarity.</span>
                      </h4>
                    </div>

                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.purple_bg}`}
                    >
                      <h4
                        className={styles.number_cont}
                      >
                        Weekly chakra work ensures the entire system remains open, which makes invocations more effective.
                      </h4>
                    </div>

                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.sky_bg}`}
                    >
                      <h4
                        className={styles.number_cont}
                      >
                        The weekly Invocation of our Divine Infinite Being ensures every planetary or zodiacal act is rooted in Source, preventing imbalance.
                      </h4>
                    </div>

                    <div
                      className={`${styles.blt_nmbr_cont_box} ${styles.dark_green_bg}`}
                    >
                      <h4
                        className={styles.number_cont}
                      >
                        The monthly operation becomes a <span style={{ color: "#f6ff00" }}>powerful, precise strike</span> — an intentional act carried on the momentum of her daily and weekly work.
                      </h4>
                    </div>
                  </div>

                  <div className={styles.content_section}>
                    <p>Even though she is <span>engaging multiple systems of yoga, planetary theurgy, and astrological ritual</span>, the total time investment is remarkably small compared to the transformative scope of the work.</p>

                    <p>She does not live beside her spiritual practice — she lives <span>within a theurgic universe</span>, one in which every week is a rotation of clearing, aligning, embodying, invoking, and acting in harmony with the gods.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className="banner_modal_main"
        >
          <Box className="banner_modal_box">
            <Typography
              id="modal-modal-description"
              component="div"
              sx={{ mt: 2 }}
              className="modal_banner"
            >
              <div className="sub_modal_banner">
                <span className="close_btn" onClick={handleClose}>
                  <CloseIcon />
                </span>
                <img
                  src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/assets/images/logobanner.webp"
                  alt="bannerLogo"
                />
              </div>
            </Typography>
          </Box>
        </Modal>
      </div>
    </>
  );
}

export default Index;
